(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4612,9526],{

/***/ 84531:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.CUSTOM_EVENTS = void 0;
(function (CUSTOM_EVENTS) {
    CUSTOM_EVENTS["CHAT_STATUS_CHANGED"] = "chat-status-changed";
    CUSTOM_EVENTS["CHAT_REQUEST"] = "chat-request";
})(exports.CUSTOM_EVENTS || (exports.CUSTOM_EVENTS = {}));


/***/ }),

/***/ 18243:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = __webpack_require__(67294);
const eventDefinitions = __webpack_require__(84531);
const types = __webpack_require__(30358);

const useChatStatus = () => {
    const [status, setStatus] = react.useState(getInitialStatus());
    react.useEffect(() => {
        function handleStatusChange(event) {
            setStatus(event.detail.status);
        }
        document.addEventListener(eventDefinitions.CUSTOM_EVENTS.CHAT_STATUS_CHANGED, handleStatusChange);
        return () => {
            document.removeEventListener(eventDefinitions.CUSTOM_EVENTS.CHAT_STATUS_CHANGED, handleStatusChange);
        };
    }, []);
    return status;
};
function transformMetadataContext(metadataContext) {
    if (!metadataContext || typeof metadataContext !== 'object') {
        throw new Error('Invalid metadataContext provided');
    }
    return Object.entries(metadataContext).reduce((acc, [key, value]) => {
        acc[`context_${key}`] = value;
        return acc;
    }, {});
}
function triggerChat(triggerName, metadataContext) {
    if (!triggerName) {
        throw new Error('source name must be provided to trigger a chat');
    }
    const transformedMetadataContext = metadataContext ? transformMetadataContext(metadataContext) : undefined;
    document.dispatchEvent(new CustomEvent(eventDefinitions.CUSTOM_EVENTS.CHAT_REQUEST, {
        detail: {
            triggerName,
            metadataContext: transformedMetadataContext,
        },
    }));
}
function getInitialStatus() {
    return window.__CHAT_STATUS || types.SessionStatus.Idle;
}

Object.defineProperty(exports, "CUSTOM_EVENTS", ({
enumerable: true,
get: () => eventDefinitions.CUSTOM_EVENTS
}));
Object.defineProperty(exports, "ChatSourceName", ({
enumerable: true,
get: () => types.ChatSourceName
}));
Object.defineProperty(exports, "SessionStatus", ({
enumerable: true,
get: () => types.SessionStatus
}));
exports.triggerChat = triggerChat;
exports.useChatStatus = useChatStatus;


/***/ }),

/***/ 30358:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.SessionStatus = void 0;
(function (SessionStatus) {
    SessionStatus["Idle"] = "IDLE";
    SessionStatus["Started"] = "STARTED";
    SessionStatus["TalkingWithAgent"] = "TALKING_WITH_AGENT";
})(exports.SessionStatus || (exports.SessionStatus = {}));
exports.ChatSourceName = void 0;
(function (ChatSourceName) {
    ChatSourceName["AUTOMATION_REPORT_ISSUE"] = "automations_report_issue_button";
    ChatSourceName["AUTOMATION_CENTER"] = "automation-center";
    ChatSourceName["DIRECT_TRIGGERING_IN_PLATFORM"] = "direct_triggering";
    ChatSourceName["KNOWLEDGE_BASE_FLOATING_CHAT"] = "knowledge-base-floating-chat";
    ChatSourceName["HELP_CENTER_IN_APP"] = "HC_in_app";
    ChatSourceName["HELP_CENTER_V3"] = "help_center_v3";
    ChatSourceName["CONTACT_SALES_HOMEPAGE"] = "contact-sales-homepage";
})(exports.ChatSourceName || (exports.ChatSourceName = {}));


/***/ }),

/***/ 63805:
/***/ (function(module) {

"use strict";


module.exports = isMobile;
module.exports.isMobile = isMobile;

var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;

var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;

function isMobile (ua, opts) {
  if (!opts && ua !== null && typeof ua === 'object') opts = ua;
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent'];
  }
  if (typeof ua !== 'string') return false;
  if (!opts) opts = {};

  return opts.tablet
    ? tabletRE.test(ua)
    : mobileRE.test(ua);
}


/***/ }),

/***/ 80760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(80760),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 73066:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage/careers/careers",
      function () {
        return __webpack_require__(10379);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgSearch = function SvgSearch(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 25,
        fill: "none",
        viewBox: "0 0 26 25"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#383B45",
        fillRule: "evenodd",
        d: "M11.556.975c5.914 0 10.707 4.554 10.707 10.171 0 2.598-1.025 4.97-2.713 6.767l5.997 5.566a.717.717 0 0 1 .013 1.051.81.81 0 0 1-1.106.012l-6.028-5.594c-1.86 1.479-4.255 2.369-6.87 2.369-5.914 0-10.707-4.553-10.707-10.171S5.642.976 11.556.976m0 1.486c-5.05 0-9.143 3.888-9.143 8.685s4.093 8.685 9.143 8.685c5.049 0 9.142-3.888 9.142-8.685s-4.093-8.685-9.142-8.685",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgSearch);


/***/ }),

/***/ 10379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ CareersPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/templates/base-template.js + 56 modules
var base_template = __webpack_require__(55497);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./server/services/comeet-service/comeet-parsing-service.js
var comeet_parsing_service = __webpack_require__(37925);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./segments/desktop/banner/layouts/plain-banner/plain-banner-component.js + 1 modules
var plain_banner_component = __webpack_require__(89097);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./static/svg/light.svg
var _mask, _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgLight = function SvgLight(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 35,
        fill: "none",
        viewBox: "0 0 32 35"
    }, props), _mask || (_mask = /*#__PURE__*/ React.createElement("mask", {
        id: "path-1-inside-1_10253_3152",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M16.763 3.977c0 .44-.342.796-.762.796s-.762-.357-.762-.796V.795C15.239.356 15.58 0 16 0c.42 0 .762.356.762.795zM6.095 16.705c0-5.702 4.444-10.341 9.905-10.341 5.462 0 9.905 4.639 9.905 10.34 0 4.504-2.79 8.46-6.857 9.83v1.307c0 .439-.341.795-.762.795h-4.572c-.42 0-.761-.356-.761-.795v-1.306c-4.066-1.37-6.858-5.325-6.858-9.83m11.429 9.232a.79.79 0 0 1 .572-.77c3.7-.998 6.285-4.477 6.285-8.463 0-4.825-3.76-8.75-8.38-8.75s-8.382 3.925-8.382 8.75c0 3.987 2.585 7.467 6.286 8.462a.79.79 0 0 1 .571.77v1.11h3.048zm-2.286 7.472h1.524c.42 0 .762.357.762.796s-.341.795-.762.795h-1.524c-.42 0-.762-.356-.762-.795s.342-.796.762-.796m3.048-3.182h-4.572c-.42 0-.761.356-.761.795s.341.796.761.796h4.572c.42 0 .762-.357.762-.796s-.341-.795-.762-.795m12.952-14.318H28.19c-.42 0-.762.356-.762.795s.342.796.762.796h3.048c.42 0 .762-.357.762-.796s-.342-.795-.762-.795m-30.476 0H3.81c.42 0 .761.356.761.795s-.34.796-.761.796H.762c-.42 0-.762-.357-.762-.796s.341-.795.762-.795m6.079-7.64a.743.743 0 0 0 1.079 0 .82.82 0 0 0 0-1.126L4.684 3.767a.74.74 0 0 0-1.077 0 .82.82 0 0 0 0 1.125zm18.316 0a.75.75 0 0 1-.54.233.75.75 0 0 1-.538-.23.82.82 0 0 1 0-1.126l3.234-3.377a.74.74 0 0 1 1.077 0 .82.82 0 0 1 0 1.125z",
        clipRule: "evenodd"
    }))), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#181B34",
        fillRule: "evenodd",
        d: "M16.763 3.977c0 .44-.342.796-.762.796s-.762-.357-.762-.796V.795C15.239.356 15.58 0 16 0c.42 0 .762.356.762.795zM6.095 16.705c0-5.702 4.444-10.341 9.905-10.341 5.462 0 9.905 4.639 9.905 10.34 0 4.504-2.79 8.46-6.857 9.83v1.307c0 .439-.341.795-.762.795h-4.572c-.42 0-.761-.356-.761-.795v-1.306c-4.066-1.37-6.858-5.325-6.858-9.83m11.429 9.232a.79.79 0 0 1 .572-.77c3.7-.998 6.285-4.477 6.285-8.463 0-4.825-3.76-8.75-8.38-8.75s-8.382 3.925-8.382 8.75c0 3.987 2.585 7.467 6.286 8.462a.79.79 0 0 1 .571.77v1.11h3.048zm-2.286 7.472h1.524c.42 0 .762.357.762.796s-.341.795-.762.795h-1.524c-.42 0-.762-.356-.762-.795s.342-.796.762-.796m3.048-3.182h-4.572c-.42 0-.761.356-.761.795s.341.796.761.796h4.572c.42 0 .762-.357.762-.796s-.341-.795-.762-.795m12.952-14.318H28.19c-.42 0-.762.356-.762.795s.342.796.762.796h3.048c.42 0 .762-.357.762-.796s-.342-.795-.762-.795m-30.476 0H3.81c.42 0 .761.356.761.795s-.34.796-.761.796H.762c-.42 0-.762-.357-.762-.796s.341-.795.762-.795m6.079-7.64a.743.743 0 0 0 1.079 0 .82.82 0 0 0 0-1.126L4.684 3.767a.74.74 0 0 0-1.077 0 .82.82 0 0 0 0 1.125zm18.316 0a.75.75 0 0 1-.54.233.75.75 0 0 1-.538-.23.82.82 0 0 1 0-1.126l3.234-3.377a.74.74 0 0 1 1.077 0 .82.82 0 0 1 0 1.125z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#181B34",
        d: "m19.048 26.535-.408-1.212-.87.293v.919zm-6.095 0h1.278v-.919l-.87-.293zm5.143-1.369.332 1.235zm-4.191 0 .332-1.234zm.571 1.88h-1.278v1.278h1.278zm3.048 0v1.278h1.278v-1.279zM6.841 8.267l-.924.884zm1.079 0 .918.89.005-.006zm0-1.125.923-.884zM4.684 3.767l-.923.885zm-1.077 0-.923-.884zm0 1.125.923-.884zm21.55 3.378.919.889.004-.005zm-1.078.001-.925.882.007.007zm0-1.125.924.885zm3.234-3.377-.923-.884zm1.077 0 .924-.884zm0 1.125.924.884zM16 6.05c1.179 0 2.041-.981 2.041-2.074h-2.557a.5.5 0 0 1 .517-.483zm-2.04-2.074c0 1.093.863 2.074 2.04 2.074V3.494a.5.5 0 0 1 .517.483zm0-3.182v3.182h2.557V.795zM16-1.278c-1.177 0-2.04.98-2.04 2.073h2.557a.5.5 0 0 1-.516.483zM18.042.795c0-1.092-.862-2.073-2.04-2.073v2.556a.5.5 0 0 1-.517-.483zm0 3.182V.795h-2.557v3.182zm-2.04 1.108c-6.22 0-11.184 5.264-11.184 11.62h2.557c0-5.049 3.922-9.063 8.626-9.063zm11.182 11.62c0-6.356-4.964-11.62-11.183-11.62v2.557c4.704 0 8.627 4.014 8.627 9.063zm-7.727 11.041c4.611-1.553 7.727-6.015 7.727-11.041h-2.556c0 3.98-2.465 7.432-5.987 8.618zm.87.095v-1.306H17.77v1.306zm-2.04 2.074c1.178 0 2.04-.982 2.04-2.074H17.77a.5.5 0 0 1 .517-.483zm-4.572 0h4.572v-2.557h-4.572zm-2.04-2.074c0 1.092.863 2.074 2.04 2.074v-2.557a.5.5 0 0 1 .517.483zm0-1.306v1.306h2.557v-1.306zm-6.857-9.83c0 5.028 3.118 9.488 7.727 11.041l.817-2.423c-3.522-1.186-5.987-4.636-5.987-8.619zm12.946 7.227c-.927.25-1.517 1.098-1.517 2.005h2.556a.49.49 0 0 1-.374.464zm5.34-7.227c0 3.44-2.228 6.388-5.34 7.227l.665 2.469c4.29-1.156 7.232-5.166 7.232-9.696zM16 9.232c3.863 0 7.103 3.3 7.103 7.471h2.557c0-5.478-4.282-10.028-9.66-10.028zm-7.102 7.471c0-4.171 3.24-7.471 7.102-7.471V6.676c-5.377 0-9.66 4.55-9.66 10.028zm5.34 7.228c-3.113-.837-5.34-3.786-5.34-7.227H6.34c0 4.532 2.941 8.542 7.232 9.696zm1.517 2.005c0-.907-.59-1.755-1.518-2.005l-.664 2.469a.49.49 0 0 1-.375-.465zm0 1.108v-1.109h-2.557v1.11zm1.769-1.278h-3.048v2.557h3.048zm-1.278.17v1.108h2.556v-1.109zm.516 6.194h-1.524v2.557h1.524zm2.04 2.074c0-1.093-.862-2.074-2.04-2.074v2.557a.5.5 0 0 1-.517-.483zm-2.04 2.073c1.178 0 2.04-.98 2.04-2.073h-2.556a.5.5 0 0 1 .516-.483zm-1.524 0h1.524v-2.556h-1.524zm-2.04-2.073c0 1.092.862 2.073 2.04 2.073v-2.556a.5.5 0 0 1 .517.483zm2.04-2.074c-1.178 0-2.04.98-2.04 2.074h2.557a.5.5 0 0 1-.517.483zm-1.524-.626h4.572V28.95h-4.572zm.517-.483a.5.5 0 0 1-.517.483V28.95c-1.177 0-2.04.98-2.04 2.073zm-.517-.483a.5.5 0 0 1 .517.483h-2.557c0 1.093.863 2.074 2.04 2.074zm4.572 0h-4.572v2.557h4.572zm-.517.483a.5.5 0 0 1 .517-.483v2.557c1.178 0 2.04-.981 2.04-2.074zm.517.483a.5.5 0 0 1-.517-.483h2.557c0-1.092-.862-2.073-2.04-2.073zm9.904-14.318h3.048V14.63H28.19zm.517-.483a.5.5 0 0 1-.517.483V14.63c-1.178 0-2.04.981-2.04 2.074zm-.517-.483a.5.5 0 0 1 .517.483H26.15c0 1.093.862 2.074 2.04 2.074zm3.048 0H28.19v2.557h3.048zm-.517.483a.5.5 0 0 1 .517-.483v2.557c1.178 0 2.04-.981 2.04-2.074zm.517.483a.5.5 0 0 1-.517-.483h2.557c0-1.093-.862-2.074-2.04-2.074zM3.81 14.63H.762v2.557H3.81zm2.04 2.074c0-1.093-.863-2.074-2.04-2.074v2.557a.5.5 0 0 1-.517-.483zm-2.04 2.074c1.177 0 2.04-.981 2.04-2.074H3.293a.5.5 0 0 1 .517-.483zm-3.048 0H3.81V16.22H.762zm-2.04-2.074c0 1.093.862 2.074 2.04 2.074V16.22a.5.5 0 0 1 .516.483zm2.04-2.074c-1.178 0-2.04.981-2.04 2.074h2.556a.5.5 0 0 1-.516.483zM7.38 7.222c.143 0 .285.058.384.162L5.917 9.152c.398.416.93.627 1.463.627zM7 7.379a.53.53 0 0 1 .38-.157v2.557c.54 0 1.066-.217 1.458-.622zm-.004.649a.46.46 0 0 1 0-.644l1.847 1.768a2.1 2.1 0 0 0 0-2.893zM3.761 4.652l3.236 3.376 1.846-1.77-3.236-3.375zm.77 0a.54.54 0 0 1-.77 0l1.847-1.769a2.02 2.02 0 0 0-2.924 0zm0-.644a.46.46 0 0 1 0 .644L2.683 2.883a2.1 2.1 0 0 0 0 2.894zm3.233 3.376L4.53 4.008 2.684 5.777l3.233 3.375zM24.618 9.78c.539 0 1.066-.217 1.458-.621L24.238 7.38a.53.53 0 0 1 .38-.158zm-1.457-.62c.392.405.92.62 1.456.62V7.223a.53.53 0 0 1 .381.16zm-.005-2.898a2.1 2.1 0 0 0-.002 2.891l1.851-1.764a.46.46 0 0 1-.002.642zm3.234-3.377-3.234 3.377 1.847 1.768 3.233-3.377zm2.924 0a2.02 2.02 0 0 0-2.924 0l1.846 1.768a.54.54 0 0 1-.769 0zm0 2.893a2.1 2.1 0 0 0 0-2.893l-1.847 1.768a.46.46 0 0 1 0-.644zM26.08 9.154l3.234-3.376-1.847-1.769-3.233 3.376z",
        mask: "url(#path-1-inside-1_10253_3152)"
    })));
};
/* harmony default export */ var light = ((/* unused pure expression or super */ null && (SvgLight)));

;// CONCATENATED MODULE: ./static/svg/careers/quote.svg
var quote_path;
function quote_extends() {
    quote_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return quote_extends.apply(this, arguments);
}

var SvgQuote = function SvgQuote(props) {
    return /*#__PURE__*/ react.createElement("svg", quote_extends({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 63 54"
    }, props), quote_path || (quote_path = /*#__PURE__*/ react.createElement("path", {
        d: "M58.259.49q3.832 0 3.832 3.632 0 1.923-1.49 2.991-11.072 8.331-11.71 19.44 6.387.427 9.794 4.272 3.406 3.631 3.406 9.186 0 5.34-3.832 9.4-3.833 3.844-9.369 3.844T39.31 48.77q-4.046-4.485-4.046-13.885t6.388-19.226 13.627-14.1Q56.98.492 58.258.492m-34.494 0q3.833 0 3.833 3.632 0 1.923-1.49 2.991-11.073 8.331-11.711 19.44 6.387.427 9.794 4.272 3.407 3.631 3.407 9.186 0 5.34-3.832 9.4-3.833 3.844-9.369 3.844T4.816 48.77Q.77 44.285.77 34.885t6.388-19.226 13.627-14.1Q22.488.492 23.765.492"
    })));
};
/* harmony default export */ var careers_quote = (SvgQuote);

;// CONCATENATED MODULE: ./static/svg/careers/filterOff.svg
var filterOff_path;
function filterOff_extends() {
    filterOff_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return filterOff_extends.apply(this, arguments);
}

var SvgFilterOff = function SvgFilterOff(props) {
    return /*#__PURE__*/ react.createElement("svg", filterOff_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21"
    }, props), filterOff_path || (filterOff_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#666972",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.713.969H.547L8.88 11.045v9.09h2.5v-9.09z"
    })));
};
/* harmony default export */ var filterOff = (SvgFilterOff);

;// CONCATENATED MODULE: ./static/svg/careers/filterOn.svg
var filterOn_path;
function filterOn_extends() {
    filterOn_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return filterOn_extends.apply(this, arguments);
}

var SvgFilterOn = function SvgFilterOn(props) {
    return /*#__PURE__*/ react.createElement("svg", filterOn_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21"
    }, props), filterOn_path || (filterOn_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#666972",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.713.969H.547L8.88 11.045v9.09h2.5v-9.09z"
    })));
};
/* harmony default export */ var filterOn = (SvgFilterOn);

;// CONCATENATED MODULE: ./static/svg/careers/filterOnCircle.svg
var _circle;
function filterOnCircle_extends() {
    filterOnCircle_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return filterOnCircle_extends.apply(this, arguments);
}

var SvgFilterOnCircle = function SvgFilterOnCircle(props) {
    return /*#__PURE__*/ react.createElement("svg", filterOnCircle_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 9,
        fill: "none",
        viewBox: "0 0 9 9"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 4.13,
        cy: 4.378,
        r: 4,
        fill: "#00CA72"
    })));
};
/* harmony default export */ var filterOnCircle = (SvgFilterOnCircle);

// EXTERNAL MODULE: ./static/svg/careers/search.svg
var search = __webpack_require__(35466);
;// CONCATENATED MODULE: ./static/svg/careers/search-alt.svg
var search_alt_path, search_alt_path2;
function search_alt_extends() {
    search_alt_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return search_alt_extends.apply(this, arguments);
}

var SvgSearchAlt = function SvgSearchAlt(props) {
    return /*#__PURE__*/ react.createElement("svg", search_alt_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 21,
        fill: "none",
        viewBox: "0 0 22 21"
    }, props), search_alt_path || (search_alt_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeWidth: 1.5,
        d: "M8.972 1.465a7.265 7.265 0 1 1 0 14.53 7.265 7.265 0 0 1 0-14.53Z",
        clipRule: "evenodd"
    })), search_alt_path2 || (search_alt_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "m15.12 14.342 5.326 5.327"
    })));
};
/* harmony default export */ var search_alt = (SvgSearchAlt);

;// CONCATENATED MODULE: ./static/svg/careers/icon-clear.svg
var _rect, _rect2, _rect3;
function icon_clear_extends() {
    icon_clear_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return icon_clear_extends.apply(this, arguments);
}

var SvgIconClear = function SvgIconClear(props) {
    return /*#__PURE__*/ react.createElement("svg", icon_clear_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), _rect || (_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 24,
        height: 24,
        fill: "#E6E9EF",
        rx: 12
    })), _rect2 || (_rect2 = /*#__PURE__*/ react.createElement("rect", {
        width: 1.5,
        height: 16.294,
        fill: "#C4C4C4",
        rx: 0.75,
        transform: "rotate(134.999 5.61 12.39)"
    })), _rect3 || (_rect3 = /*#__PURE__*/ react.createElement("rect", {
        width: 1.5,
        height: 16.294,
        fill: "#C4C4C4",
        rx: 0.75,
        transform: "rotate(-134.999 7.206 7.757)"
    })));
};
/* harmony default export */ var icon_clear = (SvgIconClear);

// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
;// CONCATENATED MODULE: ./static/svg/careers/arrow2.svg
var arrow2_path;
function arrow2_extends() {
    arrow2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return arrow2_extends.apply(this, arguments);
}

var SvgArrow2 = function SvgArrow2(props) {
    return /*#__PURE__*/ react.createElement("svg", arrow2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 12,
        fill: "none",
        viewBox: "0 0 9 12"
    }, props), arrow2_path || (arrow2_path = /*#__PURE__*/ react.createElement("path", {
        fill: "currentColor",
        d: "M3.982 11.328a.5.5 0 0 0 .707 0l3.182-3.182a.5.5 0 1 0-.707-.707l-2.828 2.829-2.828-2.829a.5.5 0 0 0-.708.707zM3.836.975v10h1v-10z"
    })));
};
/* harmony default export */ var arrow2 = (SvgArrow2);

;// CONCATENATED MODULE: ./static/svg/careers/small-caret.svg
var small_caret_path;
function small_caret_extends() {
    small_caret_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return small_caret_extends.apply(this, arguments);
}

var SvgSmallCaret = function SvgSmallCaret(props) {
    return /*#__PURE__*/ react.createElement("svg", small_caret_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        fill: "none",
        viewBox: "0 0 8 14"
    }, props), small_caret_path || (small_caret_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#C5C7D0",
        fillRule: "evenodd",
        d: "M7.634 6.282 1.918.678a.7.7 0 0 0-.496-.2.7.7 0 0 0-.497.2l-.421.413a.68.68 0 0 0 0 .974l4.8 4.706-4.806 4.71a.68.68 0 0 0 0 .975l.421.413c.133.13.31.2.497.2a.7.7 0 0 0 .497-.2l5.721-5.61a.68.68 0 0 0 .205-.488.68.68 0 0 0-.205-.489",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var small_caret = (SvgSmallCaret);

;// CONCATENATED MODULE: ./static/svg/careers/closeX.svg
var closeX_path;
function closeX_extends() {
    closeX_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return closeX_extends.apply(this, arguments);
}

var SvgCloseX = function SvgCloseX(props) {
    return /*#__PURE__*/ react.createElement("svg", closeX_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), closeX_path || (closeX_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M12.02 11.557 22.167 1.411c.4-.4.963-.489 1.256-.196.292.293.204.855-.197 1.256L13.08 12.617l10.51 10.51c.405.404.495.97.203 1.263-.293.293-.859.202-1.264-.203l-10.51-10.51L1.476 24.22c-.4.401-.963.49-1.256.197-.292-.293-.204-.855.197-1.256l10.543-10.542-10.3-10.3c-.404-.405-.495-.97-.202-1.263s.858-.202 1.263.202z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var closeX = (SvgCloseX);

;// CONCATENATED MODULE: ./static/svg/careers/back-arrow.svg
var back_arrow_path, back_arrow_path2, _path3;
function back_arrow_extends() {
    back_arrow_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return back_arrow_extends.apply(this, arguments);
}

var SvgBackArrow = function SvgBackArrow(props) {
    return /*#__PURE__*/ react.createElement("svg", back_arrow_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 25,
        fill: "none",
        viewBox: "0 0 26 25"
    }, props), back_arrow_path || (back_arrow_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#676879",
        d: "M1.404 13.154h22.898a.56.56 0 0 0 .55-.569.56.56 0 0 0-.55-.568H1.404a.56.56 0 0 0-.551.568.56.56 0 0 0 .551.569"
    })), back_arrow_path2 || (back_arrow_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#676879",
        d: "M11.486 2.75a.58.58 0 0 0-.01-.803.54.54 0 0 0-.779.01L1.01 12.188a.58.58 0 0 0 0 .794l9.687 10.232a.54.54 0 0 0 .78.01.58.58 0 0 0 .009-.804l-9.312-9.835z"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#676879",
        d: "M1.404 13.154v-.2zm22.898 0v.2zm0-1.137v.2zm-22.898 0v-.2zM11.486 2.75l-.145-.138zm-.01-.804-.141.14zm-.779.01-.145-.138zM1.01 12.188l.145.138zm0 .794.145-.137zm9.687 10.232-.145.138zm.78.01-.142-.141zm.009-.804.145-.138zm-9.312-9.835-.145-.137-.13.137.13.138zm-.77.769h22.898v-.4H1.404zm22.898 0a.76.76 0 0 0 .75-.769h-.4a.36.36 0 0 1-.35.369zm.75-.769a.76.76 0 0 0-.75-.768v.4a.36.36 0 0 1 .35.368zm-.75-.768H1.404v.4h22.898zm-22.898 0a.76.76 0 0 0-.751.768h.4a.36.36 0 0 1 .351-.368zm-.751.768c0 .419.33.769.751.769v-.4a.36.36 0 0 1-.351-.369zM11.63 2.888a.78.78 0 0 0-.013-1.082l-.283.282c.141.142.144.379.006.525zm-.013-1.082a.74.74 0 0 0-1.066.013l.29.275a.34.34 0 0 1 .493-.006zm-1.066.013L.864 12.051l.29.275 9.688-10.232zM.864 12.051a.78.78 0 0 0 0 1.069l.29-.275a.38.38 0 0 1 0-.52zm0 1.069 9.688 10.232.29-.276-9.687-10.231zm9.688 10.232a.74.74 0 0 0 1.066.012l-.283-.281a.34.34 0 0 1-.493-.006zm1.066.012a.78.78 0 0 0 .013-1.082l-.29.275a.38.38 0 0 1-.006.526zm.013-1.082L2.32 12.448l-.29.275 9.31 9.834zm-9.311-9.56 9.311-9.834-.29-.275-9.312 9.835z"
    })));
};
/* harmony default export */ var back_arrow = (SvgBackArrow);

// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/youtube-video/youtube-video-component.js + 1 modules
var youtube_video_component = __webpack_require__(14831);
// EXTERNAL MODULE: ./services/countries/countries-service.js
var countries_service = __webpack_require__(85010);
// EXTERNAL MODULE: ./components/pages/careers/careers-service.js
var careers_service = __webpack_require__(86724);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/pages/careers/careers-hero-component/careers-text-and-proof-component.scss.js

var StyledTextAndProof = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1h7qz0e0"
})("display:flex;height:100%;flex-direction:column;justify-content:space-between;.text{font-size:28px;font-weight:600;margin-bottom:50px;}.proof-badges-image{height:110px;}");

;// CONCATENATED MODULE: ./components/pages/careers/careers-hero-component/careers-text-and-proof-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



function TextAndProof(param) {
    var text = param.text, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextAndProof, {
        className: "title-and-proof",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread_props(_object_spread({}, image), {
                className: "proof-badges-image"
            }))
        ]
    });
}

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/pages/careers/scroll-top-fab/scroll-top-fab-component.scss.js


var StyledScrollTopFabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ariob70"
})("position:fixed;right:36px;bottom:36px;width:60px;height:60px;background:#e6e9ef;box-shadow:0 2px 4px 1px rgba(0,0,0,0.25);z-index:9999;border-radius:50%;display:flex;justify-content:center;align-items:center;transition:opacity 0.2s ease;opacity:0;&.is-shown{opacity:1;}&.tooltip-trigger{.tooltip-contents{display:none;opacity:0;transition:opacity 0.2s ease;position:absolute;left:50%;bottom:calc(100% + 16px);transform:translateX(-50%);width:110px;padding:7px 0;border-radius:5px;color:#ffffff;background:#676879;font-size:0.731rem;line-height:13px;text-align:center;letter-spacing:-0.02em;}&:hover{.tooltip-contents{display:block;opacity:1;}}}&:hover{cursor:pointer;background:#e6e9ef;box-shadow:0 2px 4px 1px rgba(0,0,0,0.25);}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){right:24px;bottom:24px;&.tooltip-trigger:hover{.tooltip-contents{display:none;opacity:0;}}}");

;// CONCATENATED MODULE: ./static/svg/careers/up.svg
var up_path;
function up_extends() {
    up_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return up_extends.apply(this, arguments);
}

var SvgUp = function SvgUp(props) {
    return /*#__PURE__*/ react.createElement("svg", up_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), up_path || (up_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#676879",
        fillRule: "evenodd",
        d: "M12.578 1.049a.71.71 0 0 0-.644-.37.7.7 0 0 0-.518.203l-9.198 9.02a.708.708 0 0 0 .99 1.011l8.04-7.885v19.585a.708.708 0 1 0 1.415 0V3.115l7.951 7.798a.708.708 0 0 0 .991-1.01z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var up = (SvgUp);

;// CONCATENATED MODULE: ./components/pages/careers/scroll-top-fab/scroll-top-fab-component.js





function scroll_top_fab_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scroll_top_fab_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scroll_top_fab_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var ScrollTopFabComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ScrollTopFabComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ScrollTopFabComponent);
    function ScrollTopFabComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ScrollTopFabComponent);
        var _this;
        _this = _super.call(this, props);
        scroll_top_fab_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });
        _this.state = {
            show: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ScrollTopFabComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                if (true) {
                    window.onscroll = function() {
                        var currentScrollPos = window.pageYOffset;
                        var maxScroll = document.body.scrollHeight - window.innerHeight;
                        if (currentScrollPos > 0 && currentScrollPos < maxScroll) {
                            _this.setState({
                                show: true
                            });
                        } else {
                            _this.setState({
                                show: false
                            });
                        }
                    };
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var wrapperStyles = this.props.wrapperStyles;
                var show = this.state.show;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollTopFabComponent, {
                    className: classnames_default()("scroll-top-fab-component", "tooltip-trigger", {
                        "is-shown": show
                    }),
                    style: scroll_top_fab_component_object_spread({}, wrapperStyles),
                    onClick: this.onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(up, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tooltip-contents",
                                children: "Return to top"
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return ScrollTopFabComponent;
}(react.PureComponent);
ScrollTopFabComponent.defaultProps = {
    wrapperStyles: {}
};
/* harmony default export */ var scroll_top_fab_component = (ScrollTopFabComponent);

// EXTERNAL MODULE: ./components/pages/careers/careers-config.json
var careers_config = __webpack_require__(79969);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/pages/careers/careers-hero-component/careers-hero-component.scss.js




var StyledCareersHeroComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1f1kivm0"
})("&.section-hero{color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";background:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";padding:50px 0;display:flex;flex-direction:column;gap:50px;.side-by-side-title-and-image{.paragraph-wrapper .paragraph-body{display:none;}.core-title-container .core-title{font-size:100px;font-weight:600;line-height:100%;letter-spacing:-3px;max-width:500px;}.image-wrapper{padding:0 !important;}}.side-by-side-text-and-proof{.paragraph-wrapper .paragraph-body{font-size:16px;}}/* MEDIUM TITLE */\n    @media (max-width:", vp_sizes/* HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH */.lu, "){.side-by-side-title-and-image{.core-title-container .core-title{font-size:72px;max-width:none;}}}/* MOBILE DESIGN */\n    @media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){gap:0;.side-by-side-title-and-image{padding:0;.full-paragraph{align-items:center;text-align:center !important;}.paragraph-wrapper .paragraph-body{display:block;}}.side-by-side-text-and-proof{display:none;}}/* MOBILE TITLE */\n    @media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.side-by-side-title-and-image{.core-title-container .core-title{font-size:40px;font-weight:600;line-height:100%;letter-spacing:-1.2px;max-width:none;}}}}");

;// CONCATENATED MODULE: ./components/pages/careers/careers-hero-component/careers-hero-component.js
function careers_hero_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function careers_hero_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            careers_hero_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





function CareersHeroComponent(param) {
    var isInternalMobilityPage = param.isInternalMobilityPage, bestPlaceToWorkProps = param.bestPlaceToWorkProps;
    var getFirstFoldTexts = function getFirstFoldTexts() {
        if (isInternalMobilityPage) {
            return {
                title: "Grow with us",
                subTitle: "We’re committed to helping you develop within your role, department, and the<br>company as a whole. Use this website to explore your potential growth<br>opportunities at monday.com.<br><br>See an open position that matches your skills? Check out our guidelines and apply!<br>Don’t fit the requirements? Visit our <a href='https://growth.monday.com' target='_blank' rel='noreferrer'>PDP website</a> to learn how to get there!"
            };
        }
        return {
            title: "Join the future <br>of work",
            subTitle: "monday.com is a Work OS that lets organizations manage all their work in one place. And like our platform, we are committed to building an organization with one shared mission. <br><br>We believe that the most effective teams are built on skills and passion, which is why in our recruitment process, in addition to learning about your background and experience, we really want to understand who you are and what empowers you."
        };
    };
    var ref = getFirstFoldTexts(), title = ref.title, subTitle = ref.subTitle;
    var titleAndImageSideBySideProps = {
        contentClassName: "side-by-side-title-and-image",
        leftSizeWidth: "40%",
        rightSizeWidth: "60%",
        fullParagraph: {
            topic: {
                text: "",
                image: {
                    src: null
                }
            },
            title: title,
            body: "Come join us so together we can impact how teams work across the globe.",
            textAlign: "left",
            titleColor: "white"
        },
        asset: {
            position: "center",
            fitToContainer: true,
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/careers_site/cover_image.png"
            }
        },
        assetQuality: "q_auto",
        alignImageToScreenEdge: true
    };
    var proofAndSubtitleSideBySideProps = {
        contentClassName: "side-by-side-text-and-proof",
        leftSizeWidth: "40%",
        rightSizeWidth: "60%",
        replaceAssetComponent: full_paragraph/* default */.ZP,
        replaceAssetComponentProps: {
            topic: {
                text: "",
                image: {
                    src: null
                }
            },
            title: "",
            body: subTitle,
            textAlign: "left",
            titleColor: "white",
            textWidth: "600px"
        },
        alignImageToScreenEdge: true,
        replaceTextComponent: TextAndProof,
        replaceTextComponentProps: bestPlaceToWorkProps
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCareersHeroComponent, {
        className: "section hero section-hero",
        id: "search-positions",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], careers_hero_component_object_spread({}, titleAndImageSideBySideProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], careers_hero_component_object_spread({}, proofAndSubtitleSideBySideProps))
        ]
    });
}

// EXTERNAL MODULE: ./components/pages/careers/careers-constants.js
var careers_constants = __webpack_require__(61892);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./components/pages/careers/careers-common-style.scss.js
var careers_common_style_scss = __webpack_require__(53252);
// EXTERNAL MODULE: ./components/pages/careers/slick.scss.js
var slick_scss = __webpack_require__(14889);
// EXTERNAL MODULE: ./components/pages/careers/slick-theme.scss.js
var slick_theme_scss = __webpack_require__(85737);
// EXTERNAL MODULE: ./components/pages/careers/bulma.scss.js
var bulma_scss = __webpack_require__(51904);
;// CONCATENATED MODULE: ./components/pages/careers/careers-component.scss.js









var YELLOW = "#ffcb00";
var RED = "#fb275d";
var BLUE = "#595ad4";
var GREEN = "#00ca72";
var StyledCareersComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14f7rce0"
})("/* Monday.com color helpers:*/\n\n  ", bulma_scss/* bulmaStyles */.H, "  .has-background-yellow{background:", YELLOW, ";}.has-background-red{background:", RED, ";}.has-background-green{background:", GREEN, ";}.has-background-blue{background:", BLUE, ";}/* removing header's drop shadow to fit design */\n\n  .basic-header-content-wrapper.with-shadow{box-shadow:none;}.internal-careers-bottom-folds{display:flex;flex-direction:column;align-items:center;margin-top:50px;.internal-title{margin-bottom:50px;font-size:3em;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, '){.internal-title{font-size:1.5em;margin-bottom:0;}}.internal-careers-video{margin-bottom:50px;margin-top:30px;}}.section h3.title{font-weight:normal;font-size:2.7rem;line-height:70px;/* or 146% */\n    letter-spacing:-0.991px;strong{font-weight:bold;}}.position-counts{height:20px;font-size:1rem;line-height:100%;letter-spacing:-0.02em;color:#383b45;margin-bottom:8px;}.section-search{padding:0;position:sticky;top:72px;z-index:554;.search-filter-bar{font-weight:normal;font-size:1rem;line-height:40px;/* identical to box height,or 222% */\n      letter-spacing:-0.3px;color:#666972;div.filters-container{display:flex;margin-left:150px;legend{font-weight:600;font-size:1.125rem;line-height:40px;/* identical to box height,or 200% */\n\n          letter-spacing:-0.3px;color:#383b45;margin-right:10px;}.dropdown{margin-left:7px;}#dropdown-menu-teams{> .dropdown-content{max-height:calc(100vh - 72px - 94px);overflow:auto;}}#dropdown-menu-locations{width:528px;> .dropdown-content{max-height:calc(100vh - 72px - 94px);overflow:auto;}a.dropdown-item:not(.dropdown-title){margin:0 auto;display:inline-block;width:234px;min-width:unset;picture{position:absolute;left:0;top:0;text-align:center;}}}&.force-dropdowns-to-close .dropdown-content{display:none;}}}.search-selectors{font-weight:normal;background:white;padding:25px 0;&::after{content:"";position:absolute;right:0;bottom:0;width:100%;height:8px;box-shadow:0 4px 4px rgba(29,140,242,0.08);z-index:19;}.field{justify-content:center;}.input-search{input{width:452px;height:40px;padding-left:48px;padding-bottom:11px;box-sizing:border-box;border:1px solid #c0cade;border-radius:20px;background:#ffffff;font-size:1rem;line-height:18px;&::placeholder{color:#9699a6;font-family:"Poppins";}}.icon.search-icon{top:-1px;left:8px;svg{height:21px;path{fill:#9699a6;}}}.icon.clear-icon{top:0px;right:15px;width:24px;cursor:pointer;pointer-events:unset;}}.blue-rnd-btn{font-size:0.875rem;background:', colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";color:white;width:150px;height:40px;box-shadow:0px 3.45298px 6.90597px rgba(0,0,0,0.101025);border-radius:20px;font-weight:bold;}}}.loader-container{/* in desktop:inside section-position,in mobile:on all screen */\n    position:absolute;top:64px;left:-2px;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:1;display:flex;justify-content:center;align-items:center;}.section-positions{position:relative;padding-top:1rem;padding-bottom:150px;margin-top:56px;@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){margin-top:0;}.no-search-results{margin-top:50px;.title{font-weight:bold;font-size:1.75rem;line-height:38px;margin:7px 0 27px 0;}p{font-size:1rem;line-height:28px;/* or 156% */\n        color:#383b45;width:440px;margin:0 auto;a{color:#0085ff;text-decoration:underline;}}}table{width:100%;display:table;caption{position:absolute;top:-58px;left:0;text-align:left;font-weight:300;font-size:1rem;line-height:40px;letter-spacing:-0.3px;color:#666972;margin-bottom:14px;}td{padding:0.5em 0em 0.5em 0;border-bottom-width:2px;border-color:#e6e9ef;font-size:1rem;line-height:40px;}td.pos-name{/* tab focus is on TR - so we hide any click focus on TD */\n\n        &:focus{outline:0;}a{color:black;display:block;line-height:120%;padding:7px 0px;&:focus{outline:0;}}.media-left{margin-right:40px;margin-left:-20px;transform:scale(0.5);width:72.5px;height:49px;.team-pics-sprite{background-image:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite.png"), ");background-repeat:no-repeat;display:block;margin-top:-20px;&.team-pics-sprite-Consulting1{width:145px;height:98px;background-position:-505px -486px;}&.team-pics-sprite-Consulting2{width:145px;height:98px;background-position:-670px -10px;}&.team-pics-sprite-Consulting3{width:145px;height:98px;background-position:-670px -128px;}&.team-pics-sprite-Consulting4{width:145px;height:98px;background-position:-670px -246px;}&.team-pics-sprite-CS2{width:145px;height:98px;background-position:-670px -364px;}&.team-pics-sprite-CS3{width:145px;height:98px;background-position:-670px -482px;}&.team-pics-sprite-CS1{width:145px;height:98px;background-position:-10px -605px;}&.team-pics-sprite-CS5{width:145px;height:98px;background-position:-175px -605px;}&.team-pics-sprite-CS4{width:145px;height:98px;background-position:-340px -605px;}&.team-pics-sprite-Design1{width:145px;height:99px;background-position:-10px -10px;}&.team-pics-sprite-Design2{width:145px;height:99px;background-position:-175px -10px;}&.team-pics-sprite-Design3{width:145px;height:99px;background-position:-10px -129px;}&.team-pics-sprite-Design4{width:145px;height:99px;background-position:-175px -129px;}&.team-pics-sprite-Design5{width:145px;height:99px;background-position:-340px -10px;}&.team-pics-sprite-Finance1{width:145px;height:99px;background-position:-340px -129px;}&.team-pics-sprite-Finance2{width:145px;height:99px;background-position:-10px -248px;}&.team-pics-sprite-HR1{width:145px;height:98px;background-position:-505px -605px;}&.team-pics-sprite-HR2{width:145px;height:98px;background-position:-670px -605px;}&.team-pics-sprite-HR3{width:145px;height:98px;background-position:-835px -10px;}&.team-pics-sprite-HR4{width:145px;height:98px;background-position:-835px -128px;}&.team-pics-sprite-HR5{width:145px;height:98px;background-position:-835px -246px;}&.team-pics-sprite-Marketing1{width:145px;height:98px;background-position:-835px -364px;}&.team-pics-sprite-Marketing2{width:145px;height:98px;background-position:-835px -482px;}&.team-pics-sprite-Marketing3{width:145px;height:98px;background-position:-835px -600px;}&.team-pics-sprite-Operations2{width:145px;height:99px;background-position:-175px -248px;}&.team-pics-sprite-Operations1{width:145px;height:99px;background-position:-340px -248px;}&.team-pics-sprite-Operations3{width:145px;height:99px;background-position:-10px -367px;}&.team-pics-sprite-Partnership1{width:145px;height:99px;background-position:-175px -367px;}&.team-pics-sprite-Partnership2{width:145px;height:99px;background-position:-340px -367px;}&.team-pics-sprite-Partnership3{width:145px;height:99px;background-position:-505px -10px;}&.team-pics-sprite-Partnership4{width:145px;height:99px;background-position:-505px -129px;}&.team-pics-sprite-Partnership5{width:145px;height:99px;background-position:-505px -248px;}&.team-pics-sprite-Social_Impact1{width:145px;height:99px;background-position:-175px -367px;}&.team-pics-sprite-Social_Impact2{width:145px;height:99px;background-position:-340px -367px;}&.team-pics-sprite-Social_Impact3{width:145px;height:99px;background-position:-505px -10px;}&.team-pics-sprite-Social_Impact4{width:145px;height:99px;background-position:-505px -129px;}&.team-pics-sprite-Social_Impact5{width:145px;height:99px;background-position:-505px -248px;}&.team-pics-sprite-Product1{width:145px;height:98px;background-position:-10px -723px;}&.team-pics-sprite-Product2{width:145px;height:98px;background-position:-175px -723px;}&.team-pics-sprite-Product3{width:145px;height:98px;background-position:-340px -723px;}&.team-pics-sprite-R_D1{width:145px;height:99px;background-position:-505px -367px;}&.team-pics-sprite-R_D2{width:145px;height:99px;background-position:-10px -486px;}&.team-pics-sprite-R_D3{width:145px;height:99px;background-position:-175px -486px;}&.team-pics-sprite-R_D4{width:145px;height:99px;background-position:-340px -486px;}&.team-pics-sprite-SFS1{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -10px;}&.team-pics-sprite-SFS2{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -129px;}&.team-pics-sprite-SFS3{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -248px;}&.team-pics-sprite-SFS4{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -367px;}&.team-pics-sprite-SFS5{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -486px;}&.team-pics-sprite-Communications4{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -605px;}&.team-pics-sprite-Communications5{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -724px;}&.team-pics-sprite-Communications1{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -843px;}&.team-pics-sprite-Communications2{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -962px;}&.team-pics-sprite-Communications3{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite2.png"), ") -10px -1081px;}&.team-pics-sprite-Legal1{width:145px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_legal.png"), ") -5px -5px;}&.team-pics-sprite-Legal2{width:144px;height:98px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_legal.png"), ") -5px -114px;}&.team-pics-sprite-Legal3{width:144px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_legal.png"), ") -5px -222px;}&.team-pics-sprite-RevenueOperations1{width:144px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite.png"), ") -670px -723px;}&.team-pics-sprite-RevenueOperations2{width:144px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite.png"), ") -835px -723px;}&.team-pics-sprite-Programs1{width:144px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite.png"), ") -505px -723px;}&.team-pics-sprite-Programs2{width:144px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite.png"), ") -670px -723px;}&.team-pics-sprite-Programs3{width:144px;height:99px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/team_pics_sprite.png"), ') -835px -723px;}}}.position-name{display:block;font-style:normal;font-weight:bold;font-size:1.125rem;line-height:26px;margin:0px 0 1px 0;/* identical to box height,or 200% */\n\n          letter-spacing:-0.3px;}small{font-size:0.6875rem;line-height:18px;margin-top:4px;display:table-caption;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;/* default width works for "DESKTOP WIDE" bulma width */\n          width:645px;/* "DESKTOP" width */\n          @media (min-width:1025px) and (max-width:1215px){width:600px;}/* "TABLET" width */\n          @media (min-width:769px) and (max-width:1024px){width:400px;}}}.iconwithlabel{display:table-cell;vertical-align:middle;color:', colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";min-width:160px;&.pos-dept{}> span{span{margin-right:10px;width:30px;display:inline-block;text-align:center;vertical-align:middle;}}}}.pagination{a{border:0;font-weight:bold;font-size:0.6875rem;line-height:12px;text-align:center;color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";&:active{box-shadow:none;}&.is-current{background:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";border-radius:2px;font-weight:bold;font-size:0.875rem;line-height:16px;text-align:center;color:#ffffff;}&.directional-progress-link{svg{path{fill:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";}}&.link-prev{svg{transform:rotate(180deg);}}&.is-disabled{cursor:pointer;pointer-events:none;svg{path{fill:#c5c7d0;}}}}}}.iconwithlabel{display:table-cell;vertical-align:middle;color:#009aff;min-width:160px;&.pos-dept{}> span{span{margin-right:10px;width:30px;display:inline-block;text-align:center;vertical-align:middle;}}}.show-more-less-container{margin-top:70px;a{color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";font-weight:bold;}.show-more-less{font-size:0.875rem;svg{display:inline-block;margin-left:7px;fill:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ';}&.show-less svg{transform:rotate(180deg);}}}}.section-best-work-place-mobile{display:none !important;}.section-testimonials{position:relative;.title{color:#fb275d;margin-bottom:45px;}.quote-container{position:relative;.quote-icon{position:absolute;top:30px;left:48px;width:63px;}.quote-inner{font-weight:bold;font-size:1.125rem;line-height:32px;/* or 160% */\n\n        letter-spacing:-0.486474px;padding:45px 127px 70px 127px;width:87%;background:#f2f3f4;blockquote{font-weight:normal;font-size:1.125rem;line-height:32px;letter-spacing:-0.486474px;color:#383b45;max-width:720px;margin-bottom:64px;}.quotee-name{font-weight:bold;}.quotee-dept{font-weight:bold;}.quotee-title{font-weight:normal;color:#2d2d2d;}.quotee-img{position:absolute;right:0px;top:0px;width:277px;height:270px;.quotee-img-container{position:relative;}img{position:absolute;top:52px;left:0;height:165px;width:auto;}}}}}.section-tiles{margin-top:100px;.title{color:#595ad4;margin-bottom:62px;}.tile{/* is-child = bulma displayed tile container (not parent or ancestor) */\n\n      &.is-child{color:white;/*  > img{*/\n\n        .tile-img{width:100%;height:101%;/*101% fixed an 1px white border issue*/\n          margin:0 !important;object-fit:cover;display:block;}/* hover-effect causes the animation on hover with an overlay mask (not the texts switching) */\n\n        &.hover-effect{position:relative;&:after{content:"";width:100%;height:100%;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;background:#323338;z-index:200;-webkit-transition:0.3s ease-in-out;transition:0.3s ease-in-out;}&:hover:after,&:focus:after{opacity:0.15;}}.tile-content.back{display:none;position:relative;}&:hover,&:focus{.tile-content.front{display:none;}.tile-content.back{display:block;}}//tile-content = "our" content holder (switched w/animation)\n        .tile-content{z-index:500;&.has-brand-value{/* 1nd text style - "value" (e.g. "Transparency") - title */\n            font-weight:bold;font-size:2.025rem;display:flex;height:100%;flex-direction:row;align-items:center;justify-content:center;}/* 2nd text style - text paragraph */\n\n          &.has-text{font-size:1rem;line-height:30px;letter-spacing:-0.486474px;padding:31px;}.is-rotated-text{font-weight:bold;font-size:2.025rem;transform:rotate(-90deg);}}}}/* gapless support for bulma tiles. adapted from:https://codepen.io/hus_hmd/pen/xzBGGo*/\n\n    .tile.is-gapless{.tile.is-parent{padding:0;}.tile.is-vertical > .tile.is-child{margin-bottom:0 !important;}.notification{border-radius:0;}}}.section-news{margin-top:68px;.title{margin-bottom:82px;}.container{max-width:1042px;}.card{height:100%;.card-image{img{border-top-left-radius:16px;border-top-right-radius:16px;}}.card-content{margin-bottom:30px;.card-footer{position:absolute;bottom:10px;border-top:unset;}}}}.section-equality{.diversity-paragraph{background-color:#eeeeff;border-radius:10px;padding-right:15%;padding-left:15%;padding-top:40px;padding-bottom:40px;text-align:center;margin-right:10%;margin-left:10%;margin-bottom:40px;line-height:26px;font-size:1rem;}}.section-footer{text-align:center;margin-bottom:140px;}// custom pill-style bulma dropdown\n  .dropdown.is-pill{margin-top:4px;color:#323338;&:hover .dropdown-trigger .button,&.is-active .dropdown-trigger .button,.dropdown-trigger.has-selection .button{box-shadow:none;background:', colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";border:1px solid;border-color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";}&:hover .dropdown-trigger button,&.is-active .dropdown-trigger button{.icon{svg{transform:rotate(180deg);}}}.dropdown-trigger{button{background:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border-radius:20px;font-weight:normal;font-size:0.8125rem;letter-spacing:-0.02em;color:#383b45;border:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";border-color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";.icon svg{width:8px;}/* image for location selection */\n\n        .is-flex img{max-height:19px;margin-right:10px;}}}.dropdown-content{background:#ffffff;box-shadow:0px 4px 15px rgba(0,0,0,0.25);border-radius:8px;padding:27px;.dropdown-title{font-weight:normal;font-size:1.125rem;line-height:22px;color:#1c1f3b;padding:0;margin-bottom:17px;}.dropdown-item:not(.dropdown-title){/* slightly overridden at #dropdown-menu-locations */\n        padding:15px 17px 13px 15px;min-width:270px;margin:10px auto;font-size:0.875rem;line-height:22px;article{.media-left{width:27px;text-align:center;}.media-content{line-height:140%;strong{display:block;font-weight:bold;font-size:1.125rem;margin-bottom:11px;line-height:100%;}}}}}/* columns item variation */\n\n    &.is-columns-variation{.dropdown-content{width:600px;padding:27px 13px;}&.is-narrow{.dropdown-content{width:300px;}.column.is-half{min-width:270px;}}.columns{.dropdown-item:not(.dropdown-title){min-width:270px;padding:7px 17px 7px 9px;article{.media-left{width:unset;margin-right:14px;}.colored-ribbon{display:inline-block;width:7px;height:64px;margin-top:7px;border-top-left-radius:2px;border-bottom-left-radius:2px;}p{white-space:break-spaces;}}}}}.dropdown-item:not(.dropdown-title):hover,.is-active.dropdown-item:not(.dropdown-title){color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";background-color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";border-radius:5px;article .media-left{img{filter:invert(34%) sepia(93%) saturate(1037%) hue-rotate(218deg) brightness(98%) contrast(108%);}.colored-ribbon{background:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], " !important;}}}}", slick_theme_scss/* slickThemeStyle */.d, " ", slick_scss/* slickStyle */.r, "  \n  /* slick slider - margin between slides:*/\n  .slick-slide > div{padding:0 25px;}/* the parent */\n\n  .slick-list{margin:0 -25px;}.slick-arrow{z-index:10;cursor:pointer;width:24px;height:24px;background:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/arrow-right.png"), ") no-repeat;right:-50px;background-size:24px 24px;top:43%;}.slick-arrow.slick-prev{background-image:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/arrow-left.png"), ");right:unset;left:-50px;}/* MOBILE DESIGN */\n  @media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, '){.section-mobile-search-container{position:sticky;top:70px;background:white;z-index:10;box-shadow:0px 2px 8px rgba(0,0,0,0.15);}.section-mobile-search{padding:20px 0 10px 0;user-select:none;.has-mobile-search-width{padding-left:1rem;padding-right:1rem;}.mobile-search-input-wrapper{margin-bottom:0;.input-search{width:100%;.input{height:47px;background:#f5f6f8;padding-left:20px;border:none;border-top-left-radius:200px;border-bottom-left-radius:200px;font-weight:normal;font-size:1rem;line-height:18px;color:#666972;}.icon{/* "mag glass" icon:*/\n\n            svg{margin-top:4px;}}}.pulldown-trigger-wrapper{background:#f5f6f8;border:none;width:40px;margin-left:4px;border-top-right-radius:200px;border-bottom-right-radius:200px;.pulldown-trigger{.filter-on{display:none;}.circ{position:absolute;top:-4px;right:7px;}/* "filter" on/off icons */\n\n            svg{margin-top:13px;margin-left:5px;}}&.has-active-selection{.pulldown-trigger{.filter-on{display:block;}.filter-off{display:none;}}}}}}.position-counts{font-size:0.875rem;line-height:300%;text-align:center;letter-spacing:-0.105px;height:unset;margin:3px 0 0px 0;color:', colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";strong{color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";}}.section h3.title{font-weight:normal;font-size:1.75rem;line-height:32px;letter-spacing:-0.02em;}#mobile-search-sidemenu{position:fixed;top:0;right:calc(-100vw);width:100%;height:100%;/* on top of header */\n      z-index:10000;background:rgba(50,51,56,0.25);/* display:none;*/\n      transition:right 0.2s ease;&.is-active{right:0;}/* layout:*/\n\n      .relative-container{position:relative;height:100%;padding:58px 0 18px;.close-btn-container{position:absolute;top:0;left:0;width:60px;height:100px;background:#676879;padding:58px 0 18px;text-align:center;}.submenu-container{position:absolute;left:60px;top:0;bottom:0;right:0;background:#f6f6f6;.sub-menu{display:none;&.is-active{display:block;}.title-row{padding:44px 12px 18px 16px;margin-bottom:16px;background:white;height:100px;.back-btn{position:absolute;top:59px;left:16px;}.subtitle{font-weight:bold;font-size:1.375rem;line-height:52px;letter-spacing:-0.02em;color:#333333;&.is-left-padded{padding-left:40px;}}.clear-btn{position:absolute;right:16px;top:60px;font-size:0.875rem;line-height:24px;color:#676879;}}.menu-container{/* enables scroll */\n              position:absolute;top:110px;bottom:0;left:0;right:0;overflow:auto;.done-btn-container{background:#f6f6f6;position:sticky;bottom:0;padding:24px 8px 16px 8px;.done-btn{background:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";width:100%;border-radius:4px;font-size:1.375rem;line-height:24px;text-align:center;letter-spacing:-0.02em;color:#ffffff;filter:drop-shadow(0px 2px 8px rgba(0,0,0,0.15));}}}}.menu-row{position:relative;padding:27px 16px;height:80px;margin-bottom:4px;background:white;letter-spacing:-0.110769px;color:#333333;font-size:1rem;line-height:18px;&.team-item{padding-left:0;position:relative;.colored-ribbon{position:absolute;width:8px;left:0;top:0;bottom:0;}}article{.media-left{width:32px;text-align:center;}.media-content{font-size:0.875rem;line-height:24px;color:#323338;.content{width:calc(100vw - 164px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}strong{font-weight:normal;font-size:1.125rem;line-height:24px;margin-right:13px;}}}&.location-item{.media-left{display:flex;justify-content:center;.image{margin-top:1px;img{height:auto;width:auto;}&.slightly-upper{margin-top:-4px;}}}}/* active menu row */\n\n            &.is-active{color:#009aff;background:#dff0ff;border-radius:5px;&:after{content:url(", (0,cloudinary_service.generateCloudinaryImageUrl)("/static/img/careers/check.png"), ");position:absolute;right:10px;top:28px;}article{.media-content{color:#009aff;strong{color:#009aff;}}.media-left{img{filter:invert(63%) sepia(100%) saturate(4690%) hue-rotate(181deg) brightness(100%) contrast(107%);}}}}}}}}.loader-container{position:fixed;top:0;z-index:100;}.section-positions{position:unset;padding:0px 0 12px 0;.no-search-results{margin-top:20px;img{height:140px;}.title{font-size:1.125rem;line-height:24px;letter-spacing:-0.3px;}p{font-size:0.8125rem;line-height:22px;letter-spacing:-0.02em;max-width:95%;}}.mobile-results{> .result{padding-left:1rem;padding-right:1rem;padding-bottom:1rem;padding-top:1.1rem;font-weight:normal;font-size:0.6875rem;line-height:24px;letter-spacing:-0.3px;color:#383b45;background:white;border-bottom:6px solid #f0f0f0;&:last-child{border-bottom:none;}a,a:hover{color:#383b45;}.position-name{font-weight:bold;font-size:1rem;line-height:28px;letter-spacing:-0.3px;margin-bottom:5px;}small{display:table-caption;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:calc(100vw - 50px);margin-top:4px;font-weight:normal;font-size:0.875rem;line-height:24px;letter-spacing:-0.3px;color:#383b45;}.bottom-row{margin-top:10px;.colored-pill{/* used for location or team colored pill in mobile's results */\n              height:34px;display:inline-block;padding:7.5px 16px 8px 16px;background:#dff0ff;color:#ffffff;border-radius:16px;font-size:0.875rem;line-height:16px;&.location-pill{margin-left:10px;color:#0085ff;}}}}}.show-more-less-container{margin-top:45px;}}.section-best-work-place-mobile{display:block !important;padding:0 24px;.title-and-proof{text-align:center;}.picture-component{display:flex;justify-content:center;}}.section-testimonials{margin-top:0;.slick-arrow{display:none !important;}.slick-dots{bottom:-100px;li.slick-active button{background-color:#c0cade !important;}}.quote-container{.quote-icon{z-index:-1;width:90px;top:0;left:0;path{fill:#f2f3f4;}}.quote-inner{padding:0;width:100%;background:none;font-size:0.875rem;line-height:24px;letter-spacing:-0.486474px;blockquote{min-height:220px;padding-top:33px;font-weight:normal;font-size:0.875rem;line-height:24px;letter-spacing:-0.486474px;margin-bottom:30px;max-width:unset;}.quotee-details{font-size:0.6875rem;line-height:20px;letter-spacing:-0.486474px;padding-bottom:30px;padding-left:95px;.quotee-name{display:inline;}.quotee-title{display:inline;.pipe{display:inline;}}}.quotee-name{}.quotee-img{position:absolute;left:0px;top:unset;right:unset;bottom:0px;width:80px;height:auto;img{width:80px;border-radius:3px;position:unset;top:unset;left:unset;height:unset;}}}}}.section-tiles{.values-slider{.value-slide{/* height:328px;*/\n          height:87vw;position:relative;.value-title{text-align:center;height:50%;font-weight:bold;font-size:1.75rem;line-height:32px;/* identical to box height */\n\n            display:flex;align-items:center;justify-content:center;/* 01 Fill/White */\n\n            color:#ffffff;}&.has-background-yellow .value-title{color:#323338;}.value-image{position:absolute;top:50%;height:50%;left:0;width:100%;object-fit:cover;}.value-image.full-height{top:0;height:100%;}}}.slick-dots{bottom:-50px;}}.section-news{.container{margin-top:10px;margin-bottom:0px;.columns .column{padding-bottom:0px;}.title{margin-bottom:40px;}/* makes the card-news shorter (on mobile,only in careers-page) */\n\n        .card-news{position:relative;min-height:160px;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){min-height:110px;}.card-image{position:absolute;top:15px;left:15px;img{width:75px;height:75px;border-radius:16px;object-fit:cover;object-position:5% 5%;}}.card-content{padding:10px 10px 10px 100px;> p{font-weight:bold;font-size:0.875rem;line-height:20px;letter-spacing:-0.3px;color:#383b45;margin-bottom:0px;}.card-footer{bottom:10px;border-top:none;font-weight:normal;font-size:0.8125rem;line-height:22px;letter-spacing:-0.105px;margin-top:5px;color:", colors/* default.asphalt */.Z.asphalt, ";}}}}}.section-equality{.diversity-paragraph{margin-right:5%;margin-left:5%;padding-right:5%;padding-left:5%;font-size:0.875rem;line-height:24px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.section-best-work-place-mobile{.title-and-proof{text-align:left !important;}}}/* DESKTOP RESPONSIVE FIXES */\n  @media screen and (max-width:1408px){.section-tiles{.tile{&.is-child{.tile-content{&.has-text{padding:25px !important;/* on desktop */}}}}}}", careers_common_style_scss/* careersCommonStyles */.a);

;// CONCATENATED MODULE: ./components/pages/careers/careers-component.js







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function careers_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function careers_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            careers_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function careers_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function careers_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        careers_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














// SVGS:























// how many rows to show initally:
var COLLPASED_TABLE_RESULTS_LIMIT = 7;
var COLLPASED_TABLE_RESULTS_LIMIT_MOBILE = 3;
// how many rows to show in full page:
var TABLE_RESULTS_PAGE_SIZE = 10;
var LOCATION_URL_PARAM = "location";
var DEPARTMENT_URL_PARAM = "department";
var SEARCH_TERM_URL_PARAM = "search";
var bestPlaceToWorkProps = {
    text: "It’s official: monday.com is a certified great place to work",
    image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/careers_site/badges.png",
        alt: "best place to work badges"
    }
};
var CareersComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CareersComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CareersComponent);
    function CareersComponent(props) {
        (0,_class_call_check/* default */.Z)(this, CareersComponent);
        var _this;
        _this = _super.call(this, props);
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderBestWorkPlace", function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "section section-best-work-place-mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAndProof, careers_component_object_spread({}, bestPlaceToWorkProps))
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderTestimonialsSection", function() {
            var testimonials = _this.state.testimonials;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "section section-testimonials",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "title has-text-centered",
                            children: [
                                "What our team ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "loves "
                                }),
                                "about monday.com"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            autoplaySpeed: 8000,
                            autoplay: true,
                            infinite: true,
                            draggable: false,
                            dots: true,
                            arrows: true,
                            speed: 500,
                            pauseOnFocus: false,
                            pauseOnHover: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: false,
                            customPaging: function(i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": "Page ".concat(i + 1),
                                    type: "button",
                                    children: i + 1
                                });
                            },
                            children: testimonials && testimonials.map(function(quote, idx) {
                                // suppoting **bold** text - middle token will have bold text
                                var splitTexts = quote.text.split("**");
                                // just in case that no '**' exists in string:
                                if (splitTexts.length < 3) {
                                    splitTexts[1] = "";
                                    splitTexts[2] = "";
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "quote-slide",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "quote-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(careers_quote, {
                                                className: "quote-icon",
                                                style: {
                                                    fill: quote.color
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "quote-inner",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                                        children: [
                                                            splitTexts[0],
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: splitTexts[1]
                                                            }),
                                                            splitTexts[2]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "quotee-details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "quotee-name",
                                                                children: quote.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "quotee-title",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "mobile-only pipe",
                                                                        children: " | "
                                                                    }),
                                                                    quote.title,
                                                                    " | ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "quotee-dept",
                                                                        children: quote.dept
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                        className: "image quotee-img",
                                                        style: {
                                                            background: quote.color
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "quotee-img-container",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                                src: quote.imageUrl,
                                                                isDecorative: true
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, quote.name);
                            })
                        })
                    ]
                })
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderMondayValuesSection", function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section section-tiles",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "title has-text-centered",
                        children: [
                            "What monday.com is ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "all about"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tiles-container container desktop-only",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tile is-ancestor is-gapless",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            tabIndex: "0",
                                            className: "tile is-child has-background-yellow hover-effect",
                                            style: {
                                                color: "#383B45"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: "Transparency"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Transparency creates a culture of inclusion and alignment, ensuring everyone is on the same page while striving for success together."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tile is-6 is-parent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tile is-child",
                                            onMouseEnter: function() {
                                                return _this.trackEventImageTileHover();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                className: "tile-img",
                                                src: "/static/img/careers/tiles/wide0.png",
                                                isDecorative: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tile is-child has-background-red hover-effect",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: "Impact"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Impact is the engine behind any project of ours. We strive to do good for our customers and community, to create an environment where meaningful changes can be made."
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tile is-ancestor is-gapless",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tile is-parent is-vertical",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tile is-child",
                                                onMouseEnter: function() {
                                                    return _this.trackEventImageTileHover();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ0.png",
                                                    isDecorative: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tile is-child",
                                                onMouseEnter: function() {
                                                    return _this.trackEventImageTileHover();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ1.png",
                                                    isDecorative: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tile is-parent is-vertical",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tile is-child has-background-blue hover-effect",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "is-rotated-text",
                                                        children: "Data Driven"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Expectations will be demystified through clear goals and data-driven decision making. You'll know your role and be given the tools to empower yourself and others - all through data."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tile is-parent is-vertical",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tile is-child has-background-green hover-effect",
                                                tabIndex: "0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tile-content front has-brand-value",
                                                        children: "Accountability"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tile-content back has-text",
                                                        children: "We hold ourselves accountable for everything we do, both successes and failures. We celebrate our collective achievements, yet embrace individual responsibility while doing so."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tile is-child",
                                                onMouseEnter: function() {
                                                    return _this.trackEventImageTileHover();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ5.png",
                                                    isDecorative: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tile is-parent is-vertical",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tile is-child",
                                                onMouseEnter: function() {
                                                    return _this.trackEventImageTileHover();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ4.png",
                                                    isDecorative: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tile is-child",
                                                onMouseEnter: function() {
                                                    return _this.trackEventImageTileHover();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ2.png",
                                                    isDecorative: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tile is-ancestor is-gapless",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tile is-child has-background-green hover-effect",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: "Ownership"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Ownership means we take control of our projects from start to finish. We’re empowered to make independent decisions while knowing our team is right behind us at all times."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tile is-child",
                                            onMouseEnter: function() {
                                                return _this.trackEventImageTileHover();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                className: "tile-img",
                                                src: "/static/img/careers/tiles/squ3.png",
                                                isDecorative: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tile is-6 is-parent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tile is-child",
                                            onMouseEnter: function() {
                                                return _this.trackEventImageTileHover();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                className: "tile-img",
                                                src: "/static/img/careers/tiles/wide1.png",
                                                isDecorative: true
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "values-slider mobile-only",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, {
                            autoplaySpeed: 8000,
                            autoplay: true,
                            infinite: true,
                            draggable: false,
                            dots: true,
                            arrows: false,
                            speed: 1500,
                            pauseOnFocus: false,
                            pauseOnHover: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "value-slide container has-background-yellow",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "value-title",
                                            children: "Transparency"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide0.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "value-slide container has-background-green",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "value-title ",
                                            children: "Accountability"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide3.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "value-slide container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        className: "value-image full-height",
                                        src: "/static/img/careers/tiles/squ1.png",
                                        isDecorative: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "value-slide container has-background-red",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "value-title ",
                                            children: "Impact"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide4.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "value-slide container has-background-green",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "value-title ",
                                            children: "Ownership"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide5.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "value-slide container has-background-blue",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "value-title ",
                                            children: "Data Driven"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide1.png",
                                            isDecorative: true
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderInTheNewsSection", function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section section-news",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "title has-text-centered",
                        children: [
                            "monday.com ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "in the news"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "columns",
                            children: careers_config.news.map(function(newsItem, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "column is-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: function() {
                                            return _this.onNewsItemClicked(newsItem.link);
                                        },
                                        target: "_blank",
                                        href: newsItem.link,
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "card card-news",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "card-image",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                        className: "image is-1by1",
                                                        src: newsItem.imageUrl,
                                                        alt: newsItem.imageAlt
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "card-content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: newsItem.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                                            className: "card-footer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    "Source: ",
                                                                    newsItem.source
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, index);
                            })
                        })
                    })
                ]
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderEqualOpportunitySection", function() {
            var bottomFoldText = careers_config.bottomFoldText;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "section section-equality",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "diversity-paragraph",
                    dangerouslySetInnerHTML: {
                        __html: bottomFoldText
                    }
                })
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "buildMetaTags", function() {
            var isInternalMobilityPage = _this.isInternalMobilityPage();
            return careers_component_object_spread_props(careers_component_object_spread({}, careers_constants.META_OVERRIDE), {
                title: isInternalMobilityPage ? careers_constants.INTERNAL_JOBS_TITLE : careers_constants.TITLE,
                description: isInternalMobilityPage ? careers_constants.INTERNAL_JOBS_DESCRIPTION : careers_constants.DESCRIPTION,
                noIndex: isInternalMobilityPage,
                noFollow: isInternalMobilityPage
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onRowKeyPress", function(event, pos, selectedLocation, selectedDept) {
            _this.onPositionLinkClicked(pos.name, selectedLocation, selectedDept);
            window.location.href = _this.getPositionLink(pos);
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "isInternalMobilityPage", function() {
            var positionsType = _this.props.positionsType;
            return positionsType === careers_constants.POSITION_TYPE_INTERNAL;
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getPositionLink", function(position) {
            var careersRootUrl = _this.isInternalMobilityPage() ? careers_constants.INTERNAL_CAREERS_ROOT_URL : careers_constants.CAREERS_ROOT_URL;
            return "".concat(careersRootUrl).concat(position.uid);
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getCtaText", function() {
            if (_this.isInternalMobilityPage()) {
                return "Explore your growth";
            }
            return "Find your role";
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderExternalCareersBottomFolds", function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    _this.renderBestWorkPlace(),
                    _this.renderTestimonialsSection(),
                    _this.renderMondayValuesSection(),
                    _this.renderInTheNewsSection(),
                    _this.renderEqualOpportunitySection()
                ]
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderInternalMobilityBannerIfNeeded", function() {
            if (!_this.isInternalMobilityPage()) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(plain_banner_component["default"], {
                theme: segments_service/* WORKOS_IRIS_THEME_ID */.M1,
                withCloseIcon: false,
                bannerText: "Happy to see you here! Please read the guidelines before applying \uD83D\uDC49  ",
                bannerLinkData: {
                    text: "Read me",
                    src: "https://app.getguru.com/card/izRaBrpT/Internal-mobility-process"
                }
            });
        });
        careers_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderInternalCareersBottomFolds", function() {
            var bottomFoldText = careers_config.bottomFoldText;
            var videoDesktopHeight = "470px";
            var videoDesktopWidth = "840px";
            var videoId = "EKlJ0hnD2ME";
            var isMobileOrTabletBrowser = _this.props.isMobileOrTabletBrowser;
            var videoWidth = isMobileOrTabletBrowser ? "100%" : videoDesktopWidth;
            var videoHeight = isMobileOrTabletBrowser ? "unset" : videoDesktopHeight;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "internal-careers-bottom-folds",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "title has-text-centered internal-title",
                        children: [
                            "Internal mobility at monday.com: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "successes, stories, and tips!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "internal-careers-video",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_component/* default */.ZP, {
                            videoId: videoId,
                            muted: false,
                            volume: 100,
                            opts: {
                                width: videoWidth,
                                height: videoHeight
                            }
                        })
                    }),
                    _this.renderEqualOpportunitySection()
                ]
            });
        });
        _this.handleSearchTermInputChange = _this.handleSearchTermInputChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleSearchTermInputChangeForMobile = _this.handleSearchTermInputChangeForMobile.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleShowMoreClick = _this.handleShowMoreClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleClearSearchClick = _this.handleClearSearchClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleClearSearchTermClick = _this.handleClearSearchTermClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleMobileSideMenuToggle = _this.handleMobileSideMenuToggle.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.performSearch = _this.performSearch.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.debounceTimeout = undefined;
        _this.state = {
            testimonials: null,
            filteredPositions: null,
            // current user input:
            searchTermInput: "",
            // current search term: (after submitting search)
            searchTerm: "",
            searchTermIsDirty: false,
            selectedLocation: null,
            selectedDept: null,
            isShowMore: false,
            positionsTableData: null,
            locationsPositionCount: {},
            teamPositionCount: {},
            forceDropdownsToClose: false,
            isTeamsDropdownOpen: false,
            isLocationDropdownOpen: false,
            isMobileSideMenuOpen: false,
            currentMobileSideMenu: "main",
            departmentsDropOptions: [],
            currentPageNum: 1,
            isLoaderShown: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(CareersComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _careersConfig_testimonials;
                var _this = this;
                this.setPositionTableData().then(function() {
                    var _ref = _async_to_generator(function(data) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this.setState({
                                            positionsTableData: data
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _this.refreshFilteredTeams();
                                    _this.refreshFilteredResults();
                                    _this.refreshPositionCounts();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(data) {
                        return _ref.apply(this, arguments);
                    };
                }());
                var urlParams = new URLSearchParams(window.location.search);
                var selectedLocationId = urlParams.get(LOCATION_URL_PARAM);
                var selectedDeptId = urlParams.get(DEPARTMENT_URL_PARAM);
                var searchTerm = urlParams.get(SEARCH_TERM_URL_PARAM);
                var selectedLocation, selectedDept;
                if (selectedLocationId) {
                    selectedLocation = careers_config.locations.find(function(loc) {
                        return loc.id === selectedLocationId;
                    });
                }
                if (selectedDeptId) {
                    selectedDept = careers_config.departments.find(function(dept) {
                        return dept.id === selectedDeptId;
                    });
                }
                if (searchTerm) {
                    this.performSearch();
                    this.setState({
                        searchTerm: searchTerm,
                        searchTermInput: searchTerm
                    });
                }
                // for mobile - we show only "featured" testimonials:
                this.setState({
                    selectedLocation: selectedLocation,
                    selectedDept: selectedDept,
                    testimonials: !(0,is_mobile.isMobile)() ? careers_config.testimonials : (_careersConfig_testimonials = careers_config.testimonials) === null || _careersConfig_testimonials === void 0 ? void 0 : _careersConfig_testimonials.filter(function(t) {
                        return t.featuredInMobile;
                    })
                });
            }
        },
        {
            key: "setPositionTableData",
            value: function setPositionTableData() {
                var _this = this;
                return _async_to_generator(function() {
                    var data, findRandomLocationPosition, moveInArray, ta1idx, ta1uid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        data = _this.props.positionsData;
                        // FILTER:
                        data = data.filter(function(position) {
                            // filter all positions marked with "unlisted":
                            // filter all positions with invalid team / locations:
                            var ret = false;
                            if (position && position.department && position.department.toLowerCase() != "unlisted") {
                                var locID = position && position.location ? (0,careers_service.getLocationID)(position.location.name) : null;
                                var teamID = (0,careers_service.getDeptIDFromPosition)(position);
                                if (!locID) console.warn("Filtering position with bad locationID", locID, position);
                                if (!teamID) console.warn("Filtering position with bad teamID", teamID, position);
                                ret = locID && teamID;
                            }
                            return ret;
                        });
                        // SORT:
                        data.sort(function(a, b) {
                            return a.name > b.name ? 1 : -1;
                        });
                        findRandomLocationPosition = function(city) {
                            var notThisUID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "---z---";
                            var matches = data.filter(function(pos) {
                                return pos.uid !== notThisUID && pos.location && pos.location.city && pos.location.city.toLowerCase().indexOf(city) >= 0;
                            });
                            var rndIdx = Math.floor(Math.random() * matches.length);
                            var randomElement = matches[rndIdx];
                            return data.indexOf(randomElement);
                        };
                        moveInArray = function(arr, from, to) {
                            arr.splice(to, 0, arr.splice(from, 1)[0]);
                        };
                        ta1idx = findRandomLocationPosition("aviv");
                        moveInArray(data, ta1idx, 0);
                        if (ta1idx > -1) {
                            ta1uid = data[ta1idx].uid;
                            moveInArray(data, findRandomLocationPosition("aviv", ta1uid), 1);
                        }
                        moveInArray(data, findRandomLocationPosition("york"), 2);
                        moveInArray(data, findRandomLocationPosition("sf"), 3);
                        moveInArray(data, findRandomLocationPosition("london"), 4);
                        moveInArray(data, findRandomLocationPosition("miami"), 5);
                        return [
                            2,
                            data
                        ];
                    });
                })();
            }
        },
        {
            key: "handleTeamsDropdownButtonKeyPress",
            value: function handleTeamsDropdownButtonKeyPress(event) {
                if (event.key === "Enter") {
                    var isTeamsDropdownOpen = this.state.isTeamsDropdownOpen;
                    this.setState({
                        isTeamsDropdownOpen: !isTeamsDropdownOpen
                    });
                }
                event.preventDefault();
                return false;
            }
        },
        {
            key: "handleLocationsDropdownButtonKeyPress",
            value: function handleLocationsDropdownButtonKeyPress(event) {
                if (event.key === "Enter") {
                    var isLocationDropdownOpen = this.state.isLocationDropdownOpen;
                    this.setState({
                        isLocationDropdownOpen: !isLocationDropdownOpen
                    });
                }
            }
        },
        {
            key: "handleShowMoreClick",
            value: function handleShowMoreClick(e) {
                var isShowMore = this.state.isShowMore;
                this.setState({
                    isShowMore: !isShowMore
                });
                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                    kind: bigbrain_event_types.CAREER_KIND_SHOW_MORE_OPTIONS,
                    info1: isShowMore
                });
                this.scrollToPositions();
            }
        },
        {
            key: "handleClearSearchClick",
            value: function handleClearSearchClick(e) {
                var _this = this;
                return _async_to_generator(function() {
                    var currentMobileSideMenu;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                currentMobileSideMenu = _this.state.currentMobileSideMenu;
                                if (!(currentMobileSideMenu == "locations")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.setState({
                                        selectedLocation: null
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 2:
                                if (!(currentMobileSideMenu == "teams")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.setState({
                                        selectedDept: null
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.setState({
                                        selectedLocation: null,
                                        selectedDept: null
                                    })
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _this.refreshFilteredResults();
                                _this.refreshFilteredTeams();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleClearSearchTermClick",
            value: function handleClearSearchTermClick(e) {
                var _this = this;
                return _async_to_generator(function() {
                    var searchTerm;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setState({
                                        searchTermInput: ""
                                    })
                                ];
                            case 1:
                                _state.sent();
                                searchTerm = _this.state.searchTerm;
                                if (searchTerm != "") _this.performSearch();
                                _this.searchTermTextbox.focus();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleMobileSideMenuToggle",
            value: function handleMobileSideMenuToggle(e) {
                var isMobileSideMenuOpen = this.state.isMobileSideMenuOpen;
                this.setState({
                    isMobileSideMenuOpen: !isMobileSideMenuOpen,
                    currentMobileSideMenu: "main"
                });
            }
        },
        {
            key: "reportSearchFieldTouchedEvent",
            value: function reportSearchFieldTouchedEvent() {
                var _state = this.state, searchTermIsDirty = _state.searchTermIsDirty, searchTermInput = _state.searchTermInput;
                if (!searchTermIsDirty) {
                    BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                        kind: bigbrain_event_types.CAREER_KIND_SEARCH_FIELD_START_TYPING,
                        info1: searchTermInput,
                        placement: this.pageLoadUniqueId
                    });
                }
                this.setState({
                    searchTermIsDirty: true
                });
            }
        },
        {
            key: "handleSearchTermInputChange",
            value: function handleSearchTermInputChange(e) {
                var _this = this;
                return _async_to_generator(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        clearTimeout(_this.debounceTimeout);
                        _this.setState({
                            searchTermInput: e.target.value
                        });
                        _this.reportSearchFieldTouchedEvent();
                        _this.debounceTimeout = setTimeout(function() {
                            _this.performSearch();
                        }, careers_constants.SEARCH_DEBOUNCE_RATE);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "handleSearchTermInputChangeForMobile",
            value: function handleSearchTermInputChangeForMobile(e) {
                var _this = this;
                return _async_to_generator(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setState({
                                        searchTermInput: e.target.value
                                    })
                                ];
                            case 1:
                                _state.sent();
                                // this.performSearch();
                                _this.reportSearchFieldTouchedEvent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "performSearch",
            value: function performSearch() {
                var _this = this;
                return _async_to_generator(function() {
                    var searchTermInput;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                searchTermInput = _this.state.searchTermInput;
                                return [
                                    4,
                                    _this.setState({
                                        searchTerm: searchTermInput
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.refreshFilteredResults();
                                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                                    kind: bigbrain_event_types.CAREER_KIND_SEARCH_FIELD_SUBMITTED,
                                    info1: searchTermInput,
                                    placement: _this.pageLoadUniqueId
                                });
                                _this.updateUrlParams();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onPositionLinkClicked",
            value: function onPositionLinkClicked(posName, location, department) {
                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                    kind: bigbrain_event_types.CAREER_KIND_SPECIFIC_POSITION_CLICKED,
                    info1: posName,
                    info2: location === null || location === void 0 ? void 0 : location.name,
                    info3: department === null || department === void 0 ? void 0 : department.name,
                    placement: this.pageLoadUniqueId
                });
                return true;
            }
        },
        {
            key: "onNewsItemClicked",
            value: function onNewsItemClicked(newsUrl) {
                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                    kind: bigbrain_event_types.CAREER_KIND_NEWS_ITEM_CLICKED,
                    info1: newsUrl,
                    placement: this.pageLoadUniqueId
                });
                return true;
            }
        },
        {
            key: "handleDropdownOptionKeyPress",
            value: function handleDropdownOptionKeyPress(event, onChangeFunc) {
                if (event.key === "Enter") {
                    onChangeFunc();
                }
            }
        },
        {
            key: "updateUrlParams",
            value: function updateUrlParams() {
                var _state = this.state, selectedLocation = _state.selectedLocation, selectedDept = _state.selectedDept, searchTerm = _state.searchTerm;
                window.history.pushState({}, "", window.location.href);
                var params = new URLSearchParams(window.location.search);
                selectedLocation ? params.set(LOCATION_URL_PARAM, selectedLocation.id) : params.delete(LOCATION_URL_PARAM);
                selectedDept ? params.set(DEPARTMENT_URL_PARAM, selectedDept.id) : params.delete(DEPARTMENT_URL_PARAM);
                searchTerm ? params.set(SEARCH_TERM_URL_PARAM, searchTerm) : params.delete(SEARCH_TERM_URL_PARAM);
                window.history.pushState({}, "", "?".concat(params.toString()));
            }
        },
        {
            key: "onLocationChange",
            value: function onLocationChange(newSelectedLocation) {
                var _this = this;
                return _async_to_generator(function() {
                    var selectedLocation, newValue;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                selectedLocation = _this.state.selectedLocation;
                                newValue = selectedLocation && newSelectedLocation.id === selectedLocation.id ? null : newSelectedLocation;
                                return [
                                    4,
                                    _this.setState({
                                        selectedLocation: newValue,
                                        selectedDept: null
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.forceBulmaDropdownsToClose();
                                _this.refreshFilteredResults();
                                _this.refreshFilteredTeams();
                                _this.setState({
                                    isLocationDropdownOpen: false
                                });
                                if (newValue) {
                                    // after selecting a location in the team dropdown - we open the next dropdown.
                                    // desktop: it will stay forced open until click anywhere else, or hover on the "location" dropdown
                                    _this.setState({
                                        isTeamsDropdownOpen: true
                                    });
                                    // mobile:
                                    _this.setState({
                                        currentMobileSideMenu: "teams"
                                    });
                                }
                                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                                    kind: bigbrain_event_types.CAREER_KIND_LOCATION_FILTER_CHOSEN,
                                    info1: newSelectedLocation === null || newSelectedLocation === void 0 ? void 0 : newSelectedLocation.id,
                                    placement: _this.pageLoadUniqueId
                                });
                                _this.updateUrlParams();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resetTeamDropdownOpenState",
            value: function resetTeamDropdownOpenState() {
                // after selecting a location in the team dropdown - we open the next dropdown. it will stay forced open until click anywhere else, or hover on the "location" dropdown
                this.setState({
                    isTeamsDropdownOpen: false
                });
            }
        },
        {
            key: "setMobileSideCurrentSubMenu",
            value: function setMobileSideCurrentSubMenu(subMenuName) {
                this.setState({
                    currentMobileSideMenu: subMenuName
                });
                if (subMenuName != "main") {
                    BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                        kind: subMenuName === "teams" ? bigbrain_event_types.CAREER_KIND_FILTER_BY_TEAM : bigbrain_event_types.CAREER_KIND_FILTER_BY_LOCATION,
                        placement: this.pageLoadUniqueId
                    });
                }
            }
        },
        {
            key: "getTeamSpriteCssClassName",
            value: function getTeamSpriteCssClassName(deptInfo, teamPicSpriteIndexLastUsedPerTeam) {
                // team-pics-sprite-CS1
                // sprite file /static/img/careers/team_pics_sprite.png that is used at css class: .team-pics-sprite
                // created with https://spritegen.website-performance.org/
                // here we match a team object with a className to show the relevant team pic, making sure that images are not repeated twice in a row
                // returned class name example: team-pics-sprite-Consulting3
                if (deptInfo) {
                    var lastIndexUsedForThisTeam = deptInfo.id in teamPicSpriteIndexLastUsedPerTeam ? teamPicSpriteIndexLastUsedPerTeam[deptInfo.id] : 0;
                    var thisIndex = (lastIndexUsedForThisTeam + 1) % (deptInfo.teamPicsCount + 1);
                    if (thisIndex == 0) thisIndex = 1;
                    teamPicSpriteIndexLastUsedPerTeam[deptInfo.id] = thisIndex;
                    return deptInfo.teamPicClassName + thisIndex;
                }
            }
        },
        {
            key: "onDeptChange",
            value: function onDeptChange(newSelectedDept) {
                var _this = this;
                return _async_to_generator(function() {
                    var _state, selectedDept, isMobileSideMenuOpen, newValue;
                    return (0,tslib_es6.__generator)(this, function(_state1) {
                        switch(_state1.label){
                            case 0:
                                _state = _this.state, selectedDept = _state.selectedDept, isMobileSideMenuOpen = _state.isMobileSideMenuOpen;
                                newValue = selectedDept && newSelectedDept.id === selectedDept.id ? null : newSelectedDept;
                                return [
                                    4,
                                    _this.setState({
                                        selectedDept: newValue
                                    })
                                ];
                            case 1:
                                _state1.sent();
                                // after picking team - closing open filters:
                                // desktop:
                                _this.forceBulmaDropdownsToClose();
                                // mobile:
                                if (isMobileSideMenuOpen) _this.handleMobileSideMenuToggle();
                                _this.refreshFilteredResults();
                                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                                    kind: bigbrain_event_types.CAREER_KIND_TEAM_FILTER_CHOSEN,
                                    info1: newSelectedDept === null || newSelectedDept === void 0 ? void 0 : newSelectedDept.id,
                                    placement: _this.pageLoadUniqueId
                                });
                                _this.updateUrlParams();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "forceBulmaDropdownsToClose",
            value: function forceBulmaDropdownsToClose() {
                var _this = this;
                return _async_to_generator(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        _this.setState({
                            forceDropdownsToClose: true,
                            isTeamsDropdownOpen: false
                        });
                        setTimeout(function() {
                            _this.setState({
                                forceDropdownsToClose: false
                            });
                        }, 100);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "refreshFilteredResults",
            value: function refreshFilteredResults() {
                var _this = this;
                var _state = this.state, positionsTableData = _state.positionsTableData, searchTerm = _state.searchTerm, selectedDept = _state.selectedDept, selectedLocation = _state.selectedLocation;
                var term = searchTerm.toLowerCase();
                var searchTermTokens = searchTerm.trim().length == 0 ? [] : searchTerm.trim().split(" ");
                if (positionsTableData) {
                    try {
                        this.setState({
                            isLoaderShown: true
                        });
                        // FILTERING:
                        var filteredData = positionsTableData.filter(function(pos) {
                            if (pos.department.toLowerCase() === "unlisted") {
                                return false;
                            }
                            // implied else:
                            var dept = (0,careers_service.getDeptInfo)(pos);
                            var deptName = dept ? (0,careers_service.getDeptInfo)(pos).name : "";
                            var location = (0,careers_service.getLocationInfoFromPosition)(pos);
                            var locationName = location ? location.name : "";
                            // filtering by dept & location dropdown:
                            if (selectedDept && selectedDept.id != dept.id || selectedLocation && selectedLocation.id != location.id) {
                                return false;
                            }
                            // filtering by text search:
                            if (searchTermTokens.length == 0) return true;
                            // possible perf. improvement: pre-process this into positionsTableData
                            var positionDetails = pos.details && pos.details.map(function(elem) {
                                return elem.value;
                            }).join(" ");
                            var searchString = (pos.name + deptName + locationName + positionDetails).toLowerCase();
                            if (searchString.indexOf(term) >= 0) {
                                if (pos.name.toLowerCase().includes(term)) {
                                    pos.displayOrder = 1;
                                } else if (deptName.toLowerCase().includes(term)) {
                                    pos.displayOrder = 2;
                                } else {
                                    pos.displayOrder = 99;
                                }
                                return true;
                            }
                        });
                        // SORT: sorting again if there are any filters - to re-shuffle the previously randomed position from each location on the first page
                        var hasAnyFiltersOrSearch = selectedDept || selectedLocation || searchTerm && searchTerm.trim() != "";
                        if (hasAnyFiltersOrSearch) {
                            filteredData.sort(function(a, b) {
                                return a.displayOrder > b.displayOrder ? 1 : -1;
                            });
                        }
                        // MOCK LOAD:
                        var MOCK_WAIT_TIME_MSEC = 550;
                        setTimeout(function() {
                            _this.setState({
                                isLoaderShown: false,
                                filteredPositions: filteredData,
                                currentPageNum: 1
                            });
                        }, MOCK_WAIT_TIME_MSEC);
                        if (filteredData.length == 0) {
                            BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                                kind: bigbrain_event_types.CAREER_KIND_DIDNT_FIND_POSITION,
                                placement: this.pageLoadUniqueId
                            });
                        }
                    } catch (ex) {
                        console.error("refreshFilteredResults.err", ex);
                        this.setState({
                            isLoaderShown: false
                        });
                    }
                }
            }
        },
        {
            key: "getPositionsPage",
            value: function getPositionsPage(pageIdx) {
                var filteredPositions = this.state.filteredPositions;
                if (!filteredPositions) return [];
                return filteredPositions.slice((pageIdx - 1) * TABLE_RESULTS_PAGE_SIZE, pageIdx * TABLE_RESULTS_PAGE_SIZE);
            }
        },
        {
            key: "setPageNumber",
            value: function setPageNumber(pageNum) {
                var _this = this;
                return _async_to_generator(function() {
                    var MOCK_WAIT_TIME_MSEC;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setState({
                                        isLoaderShown: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                MOCK_WAIT_TIME_MSEC = 350;
                                setTimeout(function() {
                                    _this.setState({
                                        isLoaderShown: false,
                                        currentPageNum: pageNum
                                    });
                                    _this.scrollToPositions();
                                }, MOCK_WAIT_TIME_MSEC);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refreshPositionCounts",
            value: function refreshPositionCounts() {
                // count positions data: (do from filteredResults if requested)
                var positionsTableData = this.state.positionsTableData;
                var locationsPositionCount = {};
                careers_config.locations.map(function(loc) {
                    locationsPositionCount[loc.id] = 0;
                });
                var teamPositionCount = {};
                careers_config.departments.map(function(dept) {
                    teamPositionCount[dept.id] = 0;
                });
                positionsTableData === null || positionsTableData === void 0 ? void 0 : positionsTableData.map(function(positionObj) {
                    var locID = (0,careers_service.getLocationID)(positionObj.location.name);
                    var teamID = (0,careers_service.getDeptIDFromPosition)(positionObj);
                    locationsPositionCount[locID]++;
                    teamPositionCount[teamID]++;
                });
                this.setState({
                    locationsPositionCount: locationsPositionCount,
                    teamPositionCount: teamPositionCount
                });
            }
        },
        {
            key: "scrollToPositions",
            value: function scrollToPositions() {
                // scroll to results, adding fixed header height:
                var HEADER_HEIGHT = 72;
                var MOBILE_FIXED_HEIGHT = 130;
                var headerOffset = HEADER_HEIGHT + ((0,is_mobile.isMobile)() ? MOBILE_FIXED_HEIGHT : 0);
                var scrollTarget = document.querySelector(".section-positions").offsetTop;
                window.scrollTo({
                    top: scrollTarget - headerOffset,
                    left: 0,
                    behavior: "smooth"
                });
            }
        },
        {
            key: "getPositionShortSanitizedText",
            value: function getPositionShortSanitizedText(posObj) {
                if (!posObj || !posObj.details || posObj.details.length == 0) return;
                // sanitizing comeet text here:
                // const sanitized = parseSocialDescription(posObj.details[0]);
                var descriptionField = posObj.details.find(function(x) {
                    return x.name == "Description";
                });
                var sanitized = descriptionField ? (0,comeet_parsing_service.parseSocialDescription)(descriptionField) : "";
                var MAX_LENGTH = 150;
                var substr = sanitized.length <= MAX_LENGTH ? sanitized : sanitized.substring(0, MAX_LENGTH);
                return substr;
            }
        },
        {
            key: "refreshFilteredTeams",
            value: function refreshFilteredTeams() {
                var positionsTableData = this.state.positionsTableData;
                // department dropdown is filtered by the location dropdown:
                var selectedLocation = this.state.selectedLocation;
                // fallback: all options
                var refreshedOptions = careers_config.departments;
                if (selectedLocation) {
                    refreshedOptions = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var dept = _step.value;
                            // for each dept, we search if it has any job in this location:
                            var firstFound = positionsTableData.find(function(pos) {
                                return selectedLocation.id == (0,careers_service.getLocationIDFromPosition)(pos) && dept.id == (0,careers_service.getDeptIDFromPosition)(pos);
                            });
                            if (firstFound) refreshedOptions.push(dept);
                        };
                        for(var _iterator = careers_config.departments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                this.setState({
                    departmentsDropOptions: refreshedOptions
                });
            }
        },
        {
            key: "onBottomCTAClick",
            value: function onBottomCTAClick() {
                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                    kind: bigbrain_event_types.CAREER_KIND_SEARCH_OPEN_POSITION_BOTTOM_CTA
                });
            }
        },
        {
            key: "trackEventImageTileHover",
            value: function trackEventImageTileHover() {
                BigBrain("track", bigbrain_event_types.CAREER_PAGE_CLICK, {
                    kind: bigbrain_event_types.CAREER_KIND_IMAGES_HOVERED
                });
            }
        },
        {
            // count all distincts in array:
            key: "countPositionLocations",
            value: function countPositionLocations(positions) {
                if (positions) {
                    var positionLocations = positions.map(function(pos) {
                        return (0,careers_service.getLocationIDFromPosition)(pos);
                    });
                    return (0,_to_consumable_array/* default */.Z)(new Set(positionLocations)).length;
                }
            }
        },
        {
            key: "countPositionTeams",
            value: function countPositionTeams(positions) {
                if (positions) {
                    var positionTeams = positions.map(function(pos) {
                        return (0,careers_service.getDeptIDFromPosition)(pos);
                    });
                    return (0,_to_consumable_array/* default */.Z)(new Set(positionTeams)).length;
                }
            }
        },
        {
            key: "getPaginationArray",
            value: function getPaginationArray(c, m) {
                // https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
                // returns an array of page numbers, and '...''s,
                // e.g. [1, "...", 8, 9, 10, 11, 12, "...", 20]
                var current = c, last = m, delta = (0,is_mobile.isMobile)() ? 1 : 2, left = current - delta, right = current + delta + 1, range = [], rangeWithDots = [];
                var l;
                for(var i = 1; i <= last; i++){
                    if (i == 1 || i == last || i >= left && i < right) {
                        range.push(i);
                    }
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = range[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i1 = _step.value;
                        if (l) {
                            if (i1 - l === 2) {
                                rangeWithDots.push(l + 1);
                            } else if (i1 - l !== 1) {
                                rangeWithDots.push("...");
                            }
                        }
                        rangeWithDots.push(i1);
                        l = i1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return rangeWithDots;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _state = this.state, selectedLocation = _state.selectedLocation, selectedDept = _state.selectedDept, searchTermInput = _state.searchTermInput, forceDropdownsToClose = _state.forceDropdownsToClose, departmentsDropOptions = _state.departmentsDropOptions, filteredPositions = _state.filteredPositions, isShowMore = _state.isShowMore, locationsPositionCount = _state.locationsPositionCount, teamPositionCount = _state.teamPositionCount, isTeamsDropdownOpen = _state.isTeamsDropdownOpen, isLocationDropdownOpen = _state.isLocationDropdownOpen, isMobileSideMenuOpen = _state.isMobileSideMenuOpen, currentMobileSideMenu = _state.currentMobileSideMenu, currentPageNum = _state.currentPageNum, isLoaderShown = _state.isLoaderShown;
                var locationsDropOptions = careers_config.locations;
                var numOfPages = !filteredPositions ? 1 : Math.ceil(filteredPositions.length / TABLE_RESULTS_PAGE_SIZE);
                var paginationArray = this.getPaginationArray(currentPageNum, numOfPages);
                var isInternalMobilityPage = this.isInternalMobilityPage();
                var ctaText = this.getCtaText();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, careers_component_object_spread_props(careers_component_object_spread(careers_component_object_spread_props(careers_component_object_spread({}, this.props), {
                    enableHotjar: true
                }), this.buildMetaTags()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(scroll_top_fab_component, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {
                            showMenu: !isInternalMobilityPage,
                            showButton: !isInternalMobilityPage,
                            trackScroll: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCareersComponent, {
                            className: classnames_default()("careers-component", {
                                internal: isInternalMobilityPage
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                    id: element_ids/* MAIN_ID */.k,
                                    onClick: function() {
                                        return _this.resetTeamDropdownOpenState();
                                    },
                                    children: [
                                        this.renderInternalMobilityBannerIfNeeded(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CareersHeroComponent, {
                                            isInternalMobilityPage: isInternalMobilityPage,
                                            bestPlaceToWorkProps: bestPlaceToWorkProps
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            className: "desktop-only section-search section",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "search-selectors",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "field is-grouped",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "control has-icons-right input-search",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "search",
                                                                    ref: function(input) {
                                                                        _this.searchTermTextbox = input;
                                                                    },
                                                                    value: searchTermInput,
                                                                    onChange: this.handleSearchTermInputChange,
                                                                    onKeyPress: function(event) {
                                                                        if (event.key === "Enter") {
                                                                            _this.performSearch();
                                                                        }
                                                                    },
                                                                    className: "input",
                                                                    placeholder: "Search role, team, location",
                                                                    "aria-label": "Search role, team, location"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "icon is-small is-left search-icon",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search/* default */.Z, {})
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: classnames_default()("icon", "is-small", "is-right", "clear-icon", {
                                                                        "is-hidden": searchTermInput === ""
                                                                    }),
                                                                    onClick: this.handleClearSearchTermClick,
                                                                    "aria-label": "Clear search term",
                                                                    tabIndex: "0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_clear, {})
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "button blue-rnd-btn",
                                                            onClick: this.performSearch,
                                                            children: ctaText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "search-filter-bar desktop-only",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "container",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    role: "group",
                                                                    className: "filters-container ".concat(forceDropdownsToClose ? "force-dropdowns-to-close" : ""),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                                                            children: "Filter By:"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "dropdown is-pill is-right is-hoverable ".concat(isLocationDropdownOpen ? "is-active" : ""),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-trigger ".concat(selectedLocation ? "has-selection" : ""),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                        className: "button",
                                                                                        "aria-haspopup": "listbox",
                                                                                        "aria-controls": "dropdown-menu-locations",
                                                                                        onKeyPress: function(ev) {
                                                                                            return _this.handleLocationsDropdownButtonKeyPress(ev);
                                                                                        },
                                                                                        onMouseEnter: function() {
                                                                                            return _this.resetTeamDropdownOpenState();
                                                                                        },
                                                                                        children: [
                                                                                            !selectedLocation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: "All Locations"
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                className: "is-flex",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                                                                        src: selectedLocation.icon,
                                                                                                        isDecorative: true
                                                                                                    }),
                                                                                                    selectedLocation.name,
                                                                                                    " "
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "icon is-small",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {})
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-menu",
                                                                                    id: "dropdown-menu-locations",
                                                                                    role: "menu",
                                                                                    "aria-expanded": isLocationDropdownOpen,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "dropdown-content",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "dropdown-item dropdown-title",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                                    children: "Choose your favorite location"
                                                                                                })
                                                                                            }),
                                                                                            locationsDropOptions && locationsDropOptions.map(function(locData) {
                                                                                                var locationID = (0,careers_service.getLocationID)(locData.name);
                                                                                                var locationPosCount = locationID in locationsPositionCount ? locationsPositionCount[locationID] : 0;
                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                    tabIndex: "0",
                                                                                                    className: "dropdown-item ".concat(selectedLocation && selectedLocation.id == locationID ? "is-active" : ""),
                                                                                                    onClick: function() {
                                                                                                        return _this.onLocationChange(locData);
                                                                                                    },
                                                                                                    onKeyPress: function(event) {
                                                                                                        return _this.handleDropdownOptionKeyPress(event, function() {
                                                                                                            return _this.onLocationChange(locData);
                                                                                                        });
                                                                                                    },
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                                                                        className: "media",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                                                                                className: "media-left",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                                    className: "image",
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                                                                                        src: locData.icon,
                                                                                                                        isDecorative: true
                                                                                                                    })
                                                                                                                })
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                className: "media-content",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                    className: "content",
                                                                                                                    children: [
                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                                                            children: locData.name
                                                                                                                        }),
                                                                                                                        locationPosCount,
                                                                                                                        " positions",
                                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                                                                        locData.order == 1 ? "Headquarters" : ""
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                }, locData.name);
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "dropdown is-pill is-columns-variation is-right is-hoverable ".concat(isTeamsDropdownOpen ? "is-active" : "", " ").concat(departmentsDropOptions.length < 4 ? "is-narrow" : ""),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-trigger ".concat(selectedDept ? "has-selection" : ""),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                        className: "button",
                                                                                        "aria-haspopup": "listbox",
                                                                                        "aria-controls": "dropdown-menu-teams",
                                                                                        onKeyPress: function(ev) {
                                                                                            return _this.handleTeamsDropdownButtonKeyPress(ev);
                                                                                        },
                                                                                        children: [
                                                                                            !selectedDept ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: "All Teams"
                                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                children: [
                                                                                                    selectedDept.name,
                                                                                                    " "
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "icon is-small",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {})
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "dropdown-menu",
                                                                                    id: "dropdown-menu-teams",
                                                                                    role: "menu",
                                                                                    "aria-expanded": isTeamsDropdownOpen,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "dropdown-content",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "dropdown-item dropdown-title",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                                    children: "Choose your dream team"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "columns is-multiline is-gapless",
                                                                                                children: departmentsDropOptions && departmentsDropOptions.map(function(deptData) {
                                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: "column is-half",
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                            tabIndex: "0",
                                                                                                            className: "dropdown-item ".concat(selectedDept && selectedDept.id == deptData.id ? "is-active" : ""),
                                                                                                            onClick: function(e) {
                                                                                                                return _this.onDeptChange(deptData);
                                                                                                            },
                                                                                                            onKeyPress: function(event) {
                                                                                                                return _this.handleDropdownOptionKeyPress(event, function() {
                                                                                                                    return _this.onDeptChange(deptData);
                                                                                                                });
                                                                                                            },
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                                                                                className: "media",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                                                                                        className: "media-left",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                            className: "colored-ribbon",
                                                                                                                            style: {
                                                                                                                                background: deptData.color
                                                                                                                            }
                                                                                                                        })
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                        className: "media-content",
                                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                            className: "content",
                                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                                                                        children: deptData.name
                                                                                                                                    }),
                                                                                                                                    deptData.shortDesc
                                                                                                                                ]
                                                                                                                            })
                                                                                                                        })
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        })
                                                                                                    }, deptData.name);
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile-only section-mobile-search-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                className: "section section-mobile-search",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "field has-addons mobile-search-input-wrapper has-mobile-search-width",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "control has-icons-right input-search",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                                        action: "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "search",
                                                                            value: searchTermInput,
                                                                            onChange: this.handleSearchTermInputChangeForMobile,
                                                                            onKeyPress: function(event) {
                                                                                if (event.key === "Enter") {
                                                                                    _this.performSearch();
                                                                                    // hide keyboard on mobile
                                                                                    event.preventDefault();
                                                                                    if (document.activeElement) document.activeElement.blur();
                                                                                    return false;
                                                                                }
                                                                            },
                                                                            className: "input",
                                                                            placeholder: "Search role, team, location",
                                                                            "aria-label": "Search role, team, location"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon is-small is-right",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_alt, {})
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "control pulldown-trigger-wrapper ".concat(selectedDept || selectedLocation ? "has-active-selection" : ""),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "is-static pulldown-trigger",
                                                                    onClick: this.handleMobileSideMenuToggle,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filterOff, {
                                                                            className: "filter-off"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filterOn, {
                                                                            className: "filter-on"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filterOnCircle, {
                                                                            className: "filter-on circ"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "position-counts",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: filteredPositions ? filteredPositions.length : ""
                                                            }),
                                                            " jobs in",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                children: [
                                                                    " ",
                                                                    this.countPositionLocations(filteredPositions)
                                                                ]
                                                            }),
                                                            " locations in",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                children: [
                                                                    " ",
                                                                    this.countPositionTeams(filteredPositions)
                                                                ]
                                                            }),
                                                            " teams."
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "mobile-search-sidemenu",
                                            role: "menu",
                                            className: "mobile-only ".concat(isMobileSideMenuOpen ? "is-active" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative-container",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "close-btn-container",
                                                        onClick: this.handleMobileSideMenuToggle,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeX, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "submenu-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classnames_default()("sub-menu", {
                                                                    "is-active": currentMobileSideMenu === "main"
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "title-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                className: "subtitle",
                                                                                children: "Filters"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "clear-btn ".concat(selectedLocation || selectedDept ? "" : "is-hidden"),
                                                                                onClick: this.handleClearSearchClick,
                                                                                children: "Clear all"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "menu-row",
                                                                        onClick: function() {
                                                                            return _this.setMobileSideCurrentSubMenu("locations");
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                children: "By favorite location"
                                                                            }),
                                                                            " (",
                                                                            locationsDropOptions && locationsDropOptions.length,
                                                                            ")"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "menu-row",
                                                                        onClick: function() {
                                                                            return _this.setMobileSideCurrentSubMenu("teams");
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                children: "By dream team"
                                                                            }),
                                                                            " (",
                                                                            departmentsDropOptions && departmentsDropOptions.length,
                                                                            ")"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classnames_default()("sub-menu", {
                                                                    "is-active": currentMobileSideMenu === "locations"
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "title-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "back-btn",
                                                                                onClick: function() {
                                                                                    return _this.setMobileSideCurrentSubMenu("main");
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(back_arrow, {})
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                className: "subtitle is-left-padded",
                                                                                children: "Location"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "clear-btn ".concat(selectedLocation ? "" : "is-hidden"),
                                                                                onClick: this.handleClearSearchClick,
                                                                                children: "Clear"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "menu-container",
                                                                        children: [
                                                                            locationsDropOptions && locationsDropOptions.map(function(locData) {
                                                                                var locationID = (0,careers_service.getLocationID)(locData.name);
                                                                                var locationPosCount = locationID in locationsPositionCount ? locationsPositionCount[locationID] : 0;
                                                                                // MOBILE VARIATION:
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "menu-row location-item ".concat(selectedLocation && selectedLocation.id == locationID ? "is-active" : ""),
                                                                                    onClick: function() {
                                                                                        return _this.onLocationChange(locData);
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                                                        className: "media",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                                                                className: "media-left",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "image ".concat(locationID == "london" ? "slightly-upper" : "", " "),
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                                                                        src: locData.icon,
                                                                                                        isDecorative: true
                                                                                                    })
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "media-content",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: "content",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                                            children: locData.name
                                                                                                        }),
                                                                                                        "(",
                                                                                                        locationPosCount,
                                                                                                        " positions)"
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }, locData.name);
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "done-btn-container",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    className: "button done-btn",
                                                                                    onClick: this.handleMobileSideMenuToggle,
                                                                                    children: "Done"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classnames_default()("sub-menu", {
                                                                    "is-active": currentMobileSideMenu === "teams"
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "title-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "back-btn",
                                                                                onClick: function() {
                                                                                    return _this.setMobileSideCurrentSubMenu("main");
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(back_arrow, {})
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                className: "subtitle is-left-padded",
                                                                                children: " Team"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "clear-btn ".concat(selectedDept ? "" : "is-hidden"),
                                                                                onClick: this.handleClearSearchClick,
                                                                                children: "Clear"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "menu-container",
                                                                        children: [
                                                                            departmentsDropOptions && departmentsDropOptions.map(function(deptData) {
                                                                                var deptID = deptData.id;
                                                                                var deptPosCount = deptID in teamPositionCount ? teamPositionCount[deptID] : 0;
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "menu-row team-item ".concat(selectedDept && selectedDept.id == deptID ? "is-active" : ""),
                                                                                    onClick: function(e) {
                                                                                        return _this.onDeptChange(deptData);
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                                                        className: "media",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                                                                className: "media-left",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "colored-ribbon",
                                                                                                    style: {
                                                                                                        background: deptData.color
                                                                                                    }
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "media-content",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    className: "content",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                                                children: deptData.name
                                                                                                            }),
                                                                                                            "(",
                                                                                                            deptPosCount,
                                                                                                            " positions)"
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }, deptData.name);
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "done-btn-container",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    className: "button done-btn",
                                                                                    onClick: this.handleMobileSideMenuToggle,
                                                                                    children: "Done"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                            className: "section section-positions",
                                            children: [
                                                filteredPositions && filteredPositions.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "no-search-results has-text-centered",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                            src: "/static/img/careers/cactus.png",
                                                            isDecorative: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            className: "title",
                                                            children: [
                                                                "Sorry, there’s nothing here.",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                "Try using different keywords or filters :)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("loader-container", {
                                                        "is-hidden": !isLoaderShown
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                        src: "/static/img/loader/monday_loader.gif"
                                                    })
                                                }),
                                                filteredPositions && filteredPositions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "container desktop-only",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "position-counts desktop-only",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: filteredPositions ? filteredPositions.length : ""
                                                                    }),
                                                                    " jobs in",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                        children: [
                                                                            " ",
                                                                            this.countPositionLocations(filteredPositions)
                                                                        ]
                                                                    }),
                                                                    " locations in",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                        children: [
                                                                            " ",
                                                                            this.countPositionTeams(filteredPositions)
                                                                        ]
                                                                    }),
                                                                    " teams."
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                            className: "table",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                                    className: "is-sr-only",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: "Job Title & Description"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: "Team"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                children: "Location"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                    children: filteredPositions && this.getPositionsPage(currentPageNum).map(function(pos, index) {
                                                                        var deptInfo = (0,careers_service.getDeptInfo)(pos);
                                                                        var locationInfo = (0,careers_service.getLocationInfoFromPosition)(pos);
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                            className: index >= COLLPASED_TABLE_RESULTS_LIMIT && !isShowMore ? "is-hidden" : "",
                                                                            tabIndex: "0",
                                                                            onKeyPress: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onRowKeyPress, pos, selectedLocation, selectedDept),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: "pos-name",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        href: _this.getPositionLink(pos),
                                                                                        onClick: function() {
                                                                                            return _this.onPositionLinkClicked(pos.name, selectedLocation, selectedDept);
                                                                                        },
                                                                                        tabIndex: "-1",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                                                                            className: "media",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "media-content",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: "content",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "position-name",
                                                                                                            children: pos.name
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                                            children: _this.getPositionShortSanitizedText(pos)
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: "iconwithlabel pos-dept",
                                                                                    children: deptInfo != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: deptInfo.name
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                    className: "iconwithlabel",
                                                                                    children: locationInfo != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                                                                    src: locationInfo.icon,
                                                                                                    isDecorative: true
                                                                                                })
                                                                                            }),
                                                                                            locationInfo.name
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, pos.uid);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mobile-results mobile-only",
                                                    children: filteredPositions && this.getPositionsPage(currentPageNum).map(function(pos, index) {
                                                        var deptInfo = (0,careers_service.getDeptInfo)(pos);
                                                        var locationInfo = (0,careers_service.getLocationInfoFromPosition)(pos);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: index > COLLPASED_TABLE_RESULTS_LIMIT_MOBILE && !isShowMore ? "is-hidden" : "result",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: _this.getPositionLink(pos),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "position-name",
                                                                        children: pos.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                        children: _this.getPositionShortSanitizedText(pos)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "bottom-row",
                                                                        children: [
                                                                            deptInfo != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "colored-pill",
                                                                                style: {
                                                                                    backgroundColor: deptInfo.color
                                                                                },
                                                                                children: deptInfo.name
                                                                            }),
                                                                            locationInfo != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "colored-pill location-pill",
                                                                                children: locationInfo.name
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }, pos.uid);
                                                    })
                                                }),
                                                filteredPositions && filteredPositions.length > COLLPASED_TABLE_RESULTS_LIMIT && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "show-more-less-container has-text-centered",
                                                    children: [
                                                        !isShowMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            role: "button",
                                                            tabIndex: "0",
                                                            className: " show-more-less",
                                                            onClick: this.handleShowMoreClick,
                                                            children: [
                                                                "Show more openings ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow2, {})
                                                            ]
                                                        }),
                                                        isShowMore && numOfPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                            className: "pagination is-centered",
                                                            role: "navigation",
                                                            "aria-label": "pagination",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                className: "pagination-list",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: classnames_default()("pagination-link", "directional-progress-link", "link-prev", {
                                                                                "is-disabled": currentPageNum == 1
                                                                            }),
                                                                            title: "Previous",
                                                                            onClick: function() {
                                                                                return _this.setPageNumber(currentPageNum - 1);
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(small_caret, {})
                                                                        })
                                                                    }),
                                                                    paginationArray && paginationArray.map(function(pageNum) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: pageNum === "..." ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "pagination-ellipsis",
                                                                                children: "…"
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                onClick: function() {
                                                                                    return _this.setPageNumber(pageNum);
                                                                                },
                                                                                className: classnames_default()("pagination-link", {
                                                                                    "is-current": currentPageNum == pageNum
                                                                                }),
                                                                                "aria-label": "Page ".concat(pageNum),
                                                                                children: pageNum
                                                                            })
                                                                        });
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: classnames_default()("pagination-link", "directional-progress-link", {
                                                                                "is-disabled": currentPageNum == numOfPages
                                                                            }),
                                                                            title: "Next",
                                                                            onClick: function() {
                                                                                return _this.setPageNumber(currentPageNum + 1);
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(small_caret, {})
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isInternalMobilityPage && this.renderExternalCareersBottomFolds()
                                    ]
                                }),
                                isInternalMobilityPage && this.renderInternalCareersBottomFolds(),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: "section container section-footer desktop-only",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#search-positions",
                                        className: "careers-rnd-btn",
                                        onClick: function() {
                                            return _this.onBottomCTAClick();
                                        },
                                        children: "Search open positions"
                                    })
                                })
                            ]
                        }),
                        !isInternalMobilityPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {})
                    ]
                }));
            }
        }
    ]);
    return CareersComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/pages/careers/error-careers-component/error-careers-component.js + 1 modules
var error_careers_component = __webpack_require__(54113);
// EXTERNAL MODULE: ./pages/generated-templates/base-template-page.js
var base_template_page = __webpack_require__(79813);
// EXTERNAL MODULE: ./server/services/exceptions-handling-service/exceptions-handling-service.js
var exceptions_handling_service = __webpack_require__(24730);
;// CONCATENATED MODULE: ./pages/homepage/careers/careers.js




function careers_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function careers_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            careers_define_property(target, key, source[key]);
        });
    }
    return target;
}





var CareersPage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_inherits/* default */.Z)(CareersPage, BaseTemplatePage);
    var _super = (0,_create_super/* default */.Z)(CareersPage);
    function CareersPage() {
        (0,_class_call_check/* default */.Z)(this, CareersPage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CareersPage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, positionsData = _props.positionsData, translations = _props.translations;
                if (!positionsData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_careers_component/* default */.Z, {
                    translations: translations
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CareersComponent, careers_object_spread({}, this.props));
            }
        }
    ]);
    return CareersPage;
}(base_template_page["default"]);
var __N_SSP = true;



/***/ }),

/***/ 89097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ plain_banner_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/banner.js + 2 modules
var banner = __webpack_require__(15814);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/plain-banner/plain-banner-component.scss.js

var StyledPlainBannerComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e430yr0"
})();

;// CONCATENATED MODULE: ./segments/desktop/banner/layouts/plain-banner/plain-banner-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var PlainBannerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PlainBannerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PlainBannerComponent);
    function PlainBannerComponent() {
        (0,_class_call_check/* default */.Z)(this, PlainBannerComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PlainBannerComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlainBannerComponent, {
                    className: "plain-banner-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                        showImages: false
                    }))
                });
            }
        }
    ]);
    return PlainBannerComponent;
}(react.PureComponent);
PlainBannerComponent.defaultProps = banner/* default.defaultProps */.Z.defaultProps;
/* harmony default export */ var plain_banner_component = (PlainBannerComponent);


/***/ }),

/***/ 91841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65832);


/* harmony default export */ __webpack_exports__["Z"] = ({
    contentClassName: "",
    swapTextAndAssetPosition: false,
    leftSizeWidth: null,
    rightSizeWidth: null,
    background: {},
    fullParagraph: segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
        }
    },
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__.AUTO,
    withDynamicParagraphTitle: false,
    withDynamicParagraphSubtitle: false
});


/***/ }),

/***/ 59526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SideBySideTextAndAsset; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var segments_desktop_core_components_full_paragraph_full_paragraph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13211);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(861);
/* harmony import */ var _components_core_asset_asset_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24961);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65488);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65023);
/* harmony import */ var _side_by_side_text_and_asset_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99024);
/* harmony import */ var _default_props__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91841);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var FULL_WIDTH = "100%";
var SideBySideTextAndAsset = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(SideBySideTextAndAsset, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(SideBySideTextAndAsset);
    function SideBySideTextAndAsset() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, SideBySideTextAndAsset);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "assetExist", function(asset) {
            var _asset_image, _asset_video;
            return (asset === null || asset === void 0 ? void 0 : (_asset_image = asset.image) === null || _asset_image === void 0 ? void 0 : _asset_image.src) || (asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.src);
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "onVideoStart", function() {
            var _asset_video_src_formats, _asset_video_src, _asset_video;
            var asset = _this.props.asset;
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__.ASSET_COMPONENT_VIDEO_STARTED, {
                info1: asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : (_asset_video_src = _asset_video.src) === null || _asset_video_src === void 0 ? void 0 : (_asset_video_src_formats = _asset_video_src.formats) === null || _asset_video_src_formats === void 0 ? void 0 : _asset_video_src_formats[0]
            });
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "renderAsset", function(asset) {
            var _props = _this.props, ReplaceAssetComponent = _props.replaceAssetComponent, replaceAssetComponentProps = _props.replaceAssetComponentProps, assetQuality = _props.assetQuality, useDynamicAsset = _props.useDynamicAsset, hideControls = _props.hideControls, useWindowMask = _props.useWindowMask, dynamicAssetParamPath = _props.dynamicAssetParamPath;
            if (ReplaceAssetComponent) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplaceAssetComponent, _object_spread({}, replaceAssetComponentProps));
            }
            var fitToContainer = asset.fitToContainer, assetHeight = asset.assetHeight, assetRestProps = _object_without_properties(asset, [
                "fitToContainer",
                "assetHeight"
            ]);
            var assetClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-asset", {
                "ignore-parent-height": !fitToContainer
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_asset_asset_component__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, assetRestProps), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                useWindowMask: useWindowMask,
                dynamicAssetParamPath: dynamicAssetParamPath,
                convertGifToVideo: true,
                className: assetClassName,
                imageClassName: "text-and-asset-image",
                style: {
                    height: assetHeight
                },
                onStart: _this.onVideoStart
            }));
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getFullParagraphComponentStyle", function() {
            var _props = _this.props, leftSizeWidth = _props.leftSizeWidth, nestedBoardItems = _props.nestedBoardItems;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, fullParagraphMarginTop = ref.fullParagraphMarginTop, fullParagraphMarginBottom = ref.fullParagraphMarginBottom, fullParagraphDistanceFromTop = ref.fullParagraphDistanceFromTop, parallaxAsset = ref.parallaxAsset;
            var styleObj = {
                width: leftSizeWidth,
                marginTop: fullParagraphMarginTop,
                marginBottom: fullParagraphMarginBottom
            };
            if (_this.assetExist(parallaxAsset)) {
                styleObj = _object_spread_props(_object_spread({}, styleObj), {
                    top: fullParagraphDistanceFromTop
                });
            }
            return styleObj;
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getImageWrapperStyle", function() {
            var _props = _this.props, rightSizeWidth = _props.rightSizeWidth, allowImageOverflow = _props.allowImageOverflow;
            var style = {
                width: rightSizeWidth
            };
            if (allowImageOverflow) {
                style = _object_spread_props(_object_spread({}, style), {
                    overflow: "visible"
                });
            }
            return style;
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "openLiveBoardExperience", function() {
            var _props = _this.props, nestedBoardItems = _props.nestedBoardItems, openLiveBoard = _props.openLiveBoard;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, boardBannerText = ref.boardBannerText, embeddedBoardTitle = ref.embeddedBoardTitle, addSecondLiveBoardSignUpButton = ref.addSecondLiveBoardSignUpButton, liveBoardToolTipText = ref.liveBoardToolTipText;
            openLiveBoard({
                boardBannerText: boardBannerText,
                embeddedBoardTitle: embeddedBoardTitle,
                addSecondLiveBoardSignUpButton: addSecondLiveBoardSignUpButton,
                liveBoardToolTipText: liveBoardToolTipText
            });
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "imageClicked", function(index) {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__.LIVE_BOARD_PARALLAX_ASSET_CLICKED, {
                kind: index !== undefined ? index : null
            });
            _this.openLiveBoardExperience();
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getReplaceTextProps", function() {
            var _props = _this.props, bulletsConfig = _props.bulletsConfig, iconsConfig = _props.iconsConfig, titleSize = _props.titleSize, textSize = _props.textSize, spaceFromParagraph = _props.spaceFromParagraph, withDynamicParagraphTitle = _props.withDynamicParagraphTitle, withDynamicParagraphSubtitle = _props.withDynamicParagraphSubtitle, topicBottomMargin = _props.topicBottomMargin, buttonTopMargin = _props.buttonTopMargin;
            var replaceTextProps = {};
            if (bulletsConfig) replaceTextProps.bulletsConfig = bulletsConfig;
            if (iconsConfig) replaceTextProps.iconsConfig = iconsConfig;
            if (titleSize) replaceTextProps.titleSize = titleSize;
            if (textSize) replaceTextProps.textSize = textSize;
            if (spaceFromParagraph) replaceTextProps.spaceFromParagraph = spaceFromParagraph;
            if (withDynamicParagraphTitle) replaceTextProps.withDynamicParagraphTitle = withDynamicParagraphTitle;
            if (withDynamicParagraphSubtitle) replaceTextProps.withDynamicParagraphSubtitle = withDynamicParagraphSubtitle;
            if (topicBottomMargin) replaceTextProps.topicBottomMargin = topicBottomMargin;
            if (buttonTopMargin) replaceTextProps.buttonTopMargin = buttonTopMargin;
            return replaceTextProps;
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(SideBySideTextAndAsset, [
        {
            key: "getLeftSpaceStyle",
            value: function getLeftSpaceStyle() {
                var background = this.props.background;
                var color = background.color, width = background.width;
                if (!width) return {};
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                return _object_spread({}, themeStyles);
            }
        },
        {
            key: "getBackgroundStyle",
            value: function getBackgroundStyle() {
                var _props = this.props, background = _props.background, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset;
                var width = background.width, color = background.color, verticalPadding = background.verticalPadding;
                var backgroundStyle = verticalPadding ? {
                    paddingBottom: verticalPadding,
                    paddingTop: verticalPadding
                } : {};
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                if (!width || !themeStyles) return backgroundStyle;
                var direction = swapTextAndAssetPosition ? "left" : "right";
                backgroundStyle = _object_spread_props(_object_spread({}, backgroundStyle), {
                    background: "linear-gradient(to ".concat(direction, ", ").concat(themeStyles.background, " ").concat(width, ", white 0)"),
                    color: themeStyles.color,
                    gap: spaceBetweenTextAndAsset
                });
                return backgroundStyle;
            }
        },
        {
            key: "getContentStyle",
            value: function getContentStyle() {
                var _props = this.props, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset, mobileSpaceBetweenTextAndAsset = _props.mobileSpaceBetweenTextAndAsset;
                var backgroundStyle = this.getBackgroundStyle();
                return _object_spread({
                    "--space-between-text-and-asset": spaceBetweenTextAndAsset,
                    "--mobile-space-between-text-and-asset": mobileSpaceBetweenTextAndAsset || 0
                }, backgroundStyle);
            }
        },
        {
            key: "getSideBySideComponentStyle",
            value: function getSideBySideComponentStyle() {
                var _background_backgroundImage;
                var background = this.props.background;
                var backgroundImage = background === null || background === void 0 ? void 0 : (_background_backgroundImage = background.backgroundImage) === null || _background_backgroundImage === void 0 ? void 0 : _background_backgroundImage.src;
                if (backgroundImage) {
                    var _background_backgroundImage1;
                    return {
                        background: "url(".concat(backgroundImage, ")"),
                        backgroundPosition: (background === null || background === void 0 ? void 0 : (_background_backgroundImage1 = background.backgroundImage) === null || _background_backgroundImage1 === void 0 ? void 0 : _background_backgroundImage1.backgroundPosition) || "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    };
                }
                return null;
            }
        },
        {
            key: "getRightSpaceStyle",
            value: function getRightSpaceStyle() {
                var background = this.props.background;
                var width = background.width, color = background.color;
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                if (!themeStyles) return {};
                return {
                    backgroundColor: width === FULL_WIDTH ? themeStyles.background : undefined
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, replaceTextComponent = _props.replaceTextComponent, replaceTextComponentProps = _props.replaceTextComponentProps, contentClassName = _props.contentClassName, fullParagraph = _props.fullParagraph, asset = _props.asset, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, mobileSwapTextAndAssetPosition = _props.mobileSwapTextAndAssetPosition, background = _props.background, alignToLogo = _props.alignToLogo, paragraphVerticalAlignment = _props.paragraphVerticalAlignment, alignImageToScreenEdge = _props.alignImageToScreenEdge, hideParagraph = _props.hideParagraph, nestedBoardItems = _props.nestedBoardItems;
                var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, addLiveBoardTextAndAsset = ref.addLiveBoardTextAndAsset, parallaxAsset = ref.parallaxAsset, gapBetweenAssets = ref.gapBetweenAssets;
                var parallaxAssetExists = this.assetExist(parallaxAsset);
                var leftSpaceStyle = swapTextAndAssetPosition ? this.getRightSpaceStyle() : this.getLeftSpaceStyle();
                var contentStyle = this.getContentStyle();
                var sideBySideComponentStyle = this.getSideBySideComponentStyle();
                var rightSpaceStyle = swapTextAndAssetPosition ? this.getLeftSpaceStyle() : this.getRightSpaceStyle();
                var ReplaceTextComponent = replaceTextComponent || segments_desktop_core_components_full_paragraph_full_paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP;
                var width = background.width;
                var isFullWidth = width === FULL_WIDTH;
                var renderImage = function(image, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("image-wrapper", asset === null || asset === void 0 ? void 0 : asset.position, (asset === null || asset === void 0 ? void 0 : asset.shadow) && "with-shadow", parallaxAssetExists && "inside-parallax"),
                        onClick: addLiveBoardTextAndAsset ? function() {
                            return _this.imageClicked(index);
                        } : null,
                        style: _this.getImageWrapperStyle(),
                        children: _this.renderAsset(image)
                    });
                };
                var assetsToRenderForParallax = [
                    asset,
                    parallaxAsset
                ];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_side_by_side_text_and_asset_scss__WEBPACK_IMPORTED_MODULE_7__/* .StyledSideBySideTextAndAsset */ .I, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-text-and-asset", {
                        "align-image-to-screen-edge": alignImageToScreenEdge,
                        "is-swap": swapTextAndAssetPosition,
                        "is-mobile-swap": mobileSwapTextAndAssetPosition
                    }),
                    style: sideBySideComponentStyle,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "left-space",
                            style: leftSpaceStyle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-content", paragraphVerticalAlignment, contentClassName, {
                                "is-swap": swapTextAndAssetPosition,
                                "is-mobile-swap": mobileSwapTextAndAssetPosition,
                                "is-full-width": isFullWidth,
                                "align-to-logo": !!alignToLogo,
                                "no-text-component": hideParagraph,
                                "add-live-board-experience": addLiveBoardTextAndAsset
                            }),
                            style: contentStyle,
                            children: [
                                !hideParagraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("full-paragraph-component-wrapper", parallaxAssetExists && "sticky"),
                                    style: this.getFullParagraphComponentStyle(),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplaceTextComponent, _object_spread_props(_object_spread({}, replaceTextComponentProps, fullParagraph, this.getReplaceTextProps()), {
                                        openLiveBoardExperience: addLiveBoardTextAndAsset ? this.openLiveBoardExperience : null
                                    }))
                                }),
                                parallaxAssetExists ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "parallax-wrapper",
                                    style: {
                                        gap: gapBetweenAssets
                                    },
                                    children: assetsToRenderForParallax.map(function(image, index) {
                                        return renderImage(image, index);
                                    })
                                }) : renderImage(asset)
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "right-space",
                            style: rightSpaceStyle
                        })
                    ]
                });
            }
        }
    ]);
    return SideBySideTextAndAsset;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

SideBySideTextAndAsset.defaultProps = _default_props__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;


/***/ }),

/***/ 99024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ StyledSideBySideTextAndAsset; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(698);
/* harmony import */ var segments_desktop_header_layouts_components_basic_header_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72428);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73759);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__);




var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(segments_desktop_header_layouts_components_basic_header_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADER_CONTENT_HORIZONTAL_PADDING */ .Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var BODY_HORIZONTAL_PADDING = "".concat((segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3___default().BODY_CONTENT_HORIZONTAL_PADDING), "px");
var StyledSideBySideTextAndAsset = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e43lgw60"
})("height:100%;display:flex;justify-content:center;.left-space{flex-grow:1;}.side-by-side-content{width:100%;padding:0 ", BODY_HORIZONTAL_PADDING, ";max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px;flex-grow:1;position:relative;display:flex;align-items:center;gap:var(--space-between-text-and-asset);&.top{align-items:flex-start;}&.center{align-items:center;}&.bottom{align-items:flex-end;}&.is-swap{flex-direction:row-reverse;.full-paragraph-component-wrapper{padding:0 0 0 60px;}}&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}.image-wrapper{position:relative;z-index:1;width:50%;}.full-paragraph-component-wrapper{position:relative;z-index:1;width:50%;&.sticky{position:sticky;align-self:flex-start;}}.image-wrapper.inside-parallax{width:100%;}.full-paragraph-component-wrapper{padding:0 60px 0 0;}.image-wrapper{overflow:hidden;display:flex;align-items:center;justify-content:center;&.with-shadow{", (0,segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.getComponentShadow)(), '}&.top{align-self:flex-start;}&.center{align-self:center;}&.bottom{align-self:flex-end;}.side-by-side-asset{height:100%;width:100%;&.ignore-parent-height{height:auto;}.picture-component{width:100%;height:100%;display:block;&:before{content:"";display:inline-block;height:100%;vertical-align:middle;}}.text-and-asset-image{max-width:100%;max-height:100%;width:auto;height:auto;display:inline-block;vertical-align:middle;position:relative;left:50%;transform:translateX(-50%);}}}&.add-live-board-experience{.image-wrapper{cursor:pointer;}}}.right-space{flex-grow:1;}@media (min-width:', constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_QUERY_MAX_WIDTH */ .y, "){&.align-image-to-screen-edge{.side-by-side-content{max-width:unset;&:not(.is-swap){padding-right:0;}&.is-swap{padding-left:0;}.image-wrapper{.side-by-side-asset{.text-and-asset-image{width:100%;}}}}&:not(.is-swap){.left-space{min-width:calc((100vw - ", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px) / 2);}.right-space{display:none;}}&.is-swap{padding:0 96px 0 0;.left-space{display:none;}.right-space{min-width:calc((100vw - ", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px) / 2);}}}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_QUERY_MAX_WIDTH */ .y, "){.side-by-side-content,.side-by-side-content.is-swap{flex-direction:column;gap:var(--mobile-space-between-text-and-asset);&.is-mobile-swap{flex-direction:column-reverse;}&.is-full-width{padding-top:30px;padding-bottom:45px;}.full-paragraph-component-wrapper,.image-wrapper{width:100% !important;}.full-paragraph-component-wrapper{padding:0 60px 60px 60px;}.image-wrapper{height:initial;padding-bottom:16px;}}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_QUERY_MAX_WIDTH_M */ .TI, "){.side-by-side-content{padding:0;}.side-by-side-content,.side-by-side-content.is-swap{.full-paragraph-component-wrapper{padding:0 32px 40px 32px;}.image-wrapper{padding-left:32px !important;padding-right:32px !important;}}}.parallax-wrapper{width:50%;display:flex;flex-direction:column;}");


/***/ }),

/***/ 38305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65832);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91841);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    textSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__.AUTO,
    nestedBoardItems: {
        //props that are relevant only if the live board experience is added
        addLiveBoardTextAndAsset: false,
        boardBannerText: "Sign up for free to gain full access to all features",
        embeddedBoardTitle: "Project plan",
        addSecondLiveBoardSignUpButton: false
    }
}));


/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SideBySideTextAndAssetComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59526);
/* harmony import */ var _default_props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38305);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var SideBySideTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent);
    function SideBySideTextAndAssetComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, SideBySideTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "side-by-side-text-and-asset-component",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return SideBySideTextAndAssetComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

SideBySideTextAndAssetComponent.defaultProps = _default_props__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 62587:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(62587);
exports.encode = exports.stringify = __webpack_require__(12361);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,7229,6602,390,8559,5365,4778,677,9359,9432,1036,9949,5657,932,4494,4961,1068,3211,9952,516,1360,2849,1373,3203,8885,5209,6227,3782,945,9414,9774,2888,179], function() { return __webpack_exec__(73066); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);